var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapCityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3062",
    "data-name": "Rectangle 3062",
    width: 65,
    height: 65,
    rx: 5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3061",
    "data-name": "Rectangle 3061",
    width: 78.034,
    height: 65.029,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6045",
    "data-name": "Group 6045",
    transform: "translate(14514 -779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map",
    transform: "translate(-14514 779)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6044",
    "data-name": "Group 6044",
    transform: "translate(-4.869)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6043",
    "data-name": "Group 6043",
    transform: "translate(-4.536 -3.637)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3060",
    "data-name": "Rectangle 3060",
    width: 78.034,
    height: 65.029,
    transform: "translate(4.536 3.637)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5451",
    "data-name": "Path 5451",
    d: "M-44.871,354.313s1.6.636,2.587,3.9,4.138,8.476,4.425,9.166,3.008,4.383,3.008,4.383l-2.212,1.5s-2.177-3.215-6.42.159l-19.777-.389s2.5-4.8,4.626-6.074,2.26-3.114,3.894-3.753,9.869-8.895,9.869-8.895Z",
    transform: "translate(64.438 -304.593)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M131.613,409.244s-3.487-4.357-2.466-6.858l23.674-15.546a37.18,37.18,0,0,1,3.43,3.167c.1.362,1.281,6.21.99,6.76a16.978,16.978,0,0,0-1.332,3.393c.018.481-1,5.92-1,5.92a23.174,23.174,0,0,0-8.009.92,68.765,68.765,0,0,1-11.255,1.71s-2.691.913-4.03.531h0Z",
    transform: "translate(-102.783 -332.892)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M382.71,301.75a.1.1,0,0,1-.091-.068c-.153-.512-.9-3.09-.6-3.493a.185.185,0,0,1,.152-.078c.48,0,4.73-.28,4.773-.282a.1.1,0,0,1,.013.19c-.176.012-4.3.282-4.786.282-.013.012-.153.177.207,1.719.19.81.424,1.6.427,1.606a.1.1,0,0,1-.064.118.1.1,0,0,1-.027,0h0Z",
    transform: "translate(-322.868 -255.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M367.966,346.686a.094.094,0,0,1-.094-.081.1.1,0,0,1,.079-.109l1.545-.243a.1.1,0,1,1,.03.189l-1.545.243h-.016Z",
    transform: "translate(-310.622 -297.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5455",
    "data-name": "Path 5455",
    d: "M363.192-13.893a.1.1,0,0,1-.1-.085c-.052-.4-3.981-7.473-6.609-12.134a.1.1,0,0,1,.036-.13.1.1,0,0,1,.13.036c.672,1.191,6.568,11.661,6.633,12.206a.1.1,0,0,1-.083.107h-.012Z",
    transform: "translate(-300.708 26.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6041",
    "data-name": "Group 6041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5456",
    "data-name": "Path 5456",
    d: "M-70.29-15.778a.319.319,0,0,1-.307-.234.319.319,0,0,1,.222-.391l25.041-6.913a66.984,66.984,0,0,0,7.145-3.54.317.317,0,0,1,.239-.047.317.317,0,0,1,.2.137.317.317,0,0,1,.047.239.317.317,0,0,1-.137.2,66.805,66.805,0,0,1-7.265,3.6l-.042.014L-70.2-15.79a.323.323,0,0,1-.085.012Z",
    transform: "translate(70.831 27.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6040",
    "data-name": "Group 6040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5457",
    "data-name": "Path 5457",
    d: "M-35.805,29.263A6.031,6.031,0,0,1-40.57,26.6a.1.1,0,0,1-.009-.016L-48.823,11.85-70.19,18.614a.318.318,0,0,1-.243-.02.318.318,0,0,1-.157-.187.318.318,0,0,1,.02-.243.318.318,0,0,1,.187-.157l21.613-6.844a.316.316,0,0,1,.373.148l8.367,14.951A5.475,5.475,0,0,0-35.8,28.624h.049a11.116,11.116,0,0,0,4.83-1.013c.187-.265,1.647-2.491,2.61-3.967a.216.216,0,0,1,.021-.027c2.292-2.794,2.69-2.973,2.827-3,.183-.075,1.069-.653,1.851-1.164a15.839,15.839,0,0,1,3.233-1.914,19.742,19.742,0,0,0,3.058-2.123l4.344-5.608A33.8,33.8,0,0,0-11,6.481c.065-.4.339-1.9.351-1.96a.32.32,0,0,1,.194-.238l5.9-2.384,4.48-3.787a.329.329,0,0,1,.111-.061c.215-.068,5.274-1.645,5.994-1.8.254-.056.906-.112,2.038-.2a27.9,27.9,0,0,0,4.676-.6,16.3,16.3,0,0,1,3.618-.918.318.318,0,0,1,.364.264.319.319,0,0,1-.264.364,16,16,0,0,0-3.385.832,20.633,20.633,0,0,1-4.956.689c-.89.074-1.73.143-1.953.192C5.519-2.988.883-1.546.292-1.361L-4.179,2.417a.322.322,0,0,1-.086.052l-5.79,2.337c-.077.416-.268,1.467-.317,1.778a26.352,26.352,0,0,1-2.084,3.577l-.016.022-4.376,5.65a.272.272,0,0,1-.055.055,16.7,16.7,0,0,1-3.4,2.277A29.922,29.922,0,0,0-23.27,19.98a14.894,14.894,0,0,1-2.024,1.243A26.7,26.7,0,0,0-27.794,24c-.442.678-2.521,3.859-2.651,4.021a10.373,10.373,0,0,1-5.306,1.233h-.059ZM-25.449,20.61ZM-20.3,18.166Z",
    transform: "translate(70.828 8.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M380.453,226.834a.217.217,0,0,1-.049,0,.317.317,0,0,1-.265-.363c.012-.079,1.229-7.979,1.312-11.524a34.042,34.042,0,0,0-.511-6.453c-.072-.454-.138-.883-.186-1.267a67.874,67.874,0,0,0-2.2-8.2c-.977-3.194-.369-4.855.313-5.685.25-.3,2.571-2.377,4.475-4.064.636-.563,1.161-1.026,1.19-1.051.3-.252,6.832-5.271,7.182-5.5s4.652-2.885,4.972-3.081c.213-.131,2.613-1.747,3.851-2.582a.3.3,0,0,1,.057-.03c.749-.308,2.8-1.271,3.3-2a6.679,6.679,0,0,1,2.722-1.8.32.32,0,0,1,.22.6,6.21,6.21,0,0,0-2.414,1.555c-.672,1-3.142,2.056-3.551,2.227-.354.238-3.578,2.413-3.847,2.578-.312.192-4.607,2.846-4.959,3.073-.315.2-6.846,5.223-7.121,5.452-.033.027-.511.45-1.176,1.038-2.55,2.259-4.239,3.789-4.4,3.991-.583.71-1.09,2.171-.2,5.094a67.854,67.854,0,0,1,2.219,8.308c.047.375.113.8.183,1.247a34.576,34.576,0,0,1,.519,6.567c-.085,3.587-1.307,11.527-1.319,11.606a.318.318,0,0,1-.315.269Z",
    transform: "translate(-319.475 -147.045)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M290.774,15.933l-.629-.1a.161.161,0,0,0,0,.021c0-.03.014-.354-.091-2.653a4.243,4.243,0,0,0-1.376-3.06,5.724,5.724,0,0,1-.806-1.025c-.672-1.176-.929-3.3-.763-6.308a9.266,9.266,0,0,0-.719-4.289c-.017-.038-.026-.061-.03-.07-.021-.064-2.18-6.7-2.271-6.984a.024.024,0,0,0-.005-.018l-1.656-6.323a.036.036,0,0,0-.005-.022c-.007-.036-.682-3.665-.851-4.7a10.2,10.2,0,0,0-1.588-2.674,9.721,9.721,0,0,1-.831-1.262c-.216-.5-1.891-3.012-2.518-3.938a.318.318,0,0,1-.049-.239.318.318,0,0,1,.134-.2.319.319,0,0,1,.442.085c.234.346,2.3,3.4,2.575,4.041a10.477,10.477,0,0,0,.763,1.145,9.775,9.775,0,0,1,1.7,2.942c.163,1,.8,4.447.845,4.672l1.65,6.3c.09.277,2.158,6.638,2.263,6.959l.008.018a9.934,9.934,0,0,1,.775,4.59c-.157,2.844.078,4.9.68,5.958a5.243,5.243,0,0,0,.722.91,4.84,4.84,0,0,1,1.544,3.462c.074,1.623.105,2.628.086,2.757h.005Z",
    transform: "translate(-231.2 27.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5460",
    "data-name": "Path 5460",
    d: "M127.953,358.866a.315.315,0,0,1-.242-.112c-.061-.072-1.518-1.779-2.409-3.084-.947-1.386-.671-4.017-.658-4.129a.32.32,0,0,1,.14-.23l31.263-20.673c-.2-.51-.516-1.552-.139-2.123a.877.877,0,0,1,.792-.377c1.468.025,1.732.7,1.757.782a.309.309,0,0,1,.009.161l-.281,1.39a.318.318,0,1,1-.623-.126l.255-1.263a1.58,1.58,0,0,0-1.128-.308h-.013c-.177,0-.22.065-.239.092-.2.3.057,1.23.293,1.762a.318.318,0,0,1-.116.394l-31.353,20.732a6.589,6.589,0,0,0,.564,3.554c.871,1.276,2.351,3.011,2.367,3.029a.319.319,0,0,1-.242.526h0Z",
    transform: "translate(-98.988 -281.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M-46.341,495.277h-.021l-25.656-1.687a.318.318,0,0,1-.221-.106.318.318,0,0,1-.079-.232.318.318,0,0,1,.106-.22.318.318,0,0,1,.232-.08l25.656,1.687a.318.318,0,0,1,.22.106.318.318,0,0,1,.079.232.319.319,0,0,1-.317.3h0Z",
    transform: "translate(72.316 -425.206)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5462",
    "data-name": "Path 5462",
    d: "M443.444,280.923a.241.241,0,0,1-.043,0,.317.317,0,0,1-.272-.359c.073-.535,1.791-13.125,2.331-15.219l.1-.376c.7-2.735,2.56-10,4.313-12.492.371-.527.769-1.142,1.19-1.794,1.649-2.55,3.7-5.726,6.4-7.154a53.6,53.6,0,0,1,5.768-2.66.32.32,0,0,1,.22.6,52.713,52.713,0,0,0-5.691,2.625c-2.553,1.35-4.556,4.448-6.165,6.937-.424.657-.826,1.277-1.2,1.814-1.686,2.4-3.591,9.838-4.216,12.284l-.1.377c-.531,2.059-2.3,15.016-2.316,15.146a.319.319,0,0,1-.315.276Z",
    transform: "translate(-376.089 -205.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5463",
    "data-name": "Path 5463",
    d: "M47.071-12.132c-.684,0-.812-.148-.865-.211a.3.3,0,0,1-.072-.153,64.538,64.538,0,0,0-1.584-7.469,7.286,7.286,0,0,1-.483-1.217c-.242-.724-.544-1.626-.931-1.852-.1-.056-.211-.114-.332-.177a4.126,4.126,0,0,1-2.527-3.322.318.318,0,0,1,.053-.238.318.318,0,0,1,.206-.13.318.318,0,0,1,.238.053.318.318,0,0,1,.13.206,3.533,3.533,0,0,0,2.19,2.865c.129.066.251.129.362.194a4.064,4.064,0,0,1,1.215,2.2,6.851,6.851,0,0,0,.428,1.1c.433.743,1.412,6.252,1.63,7.5a5.746,5.746,0,0,0,1.489-.077,3.436,3.436,0,0,0,1.7-.512.245.245,0,0,1,.211-.124l1.3-.191L64.57-15.819l13.742-2.035c.312-.074,5.685-1.359,8.975-2.005A9.918,9.918,0,0,0,92.087-22a.438.438,0,0,1,.047-.039l6.939-4.647a.32.32,0,0,1,.442.087.32.32,0,0,1-.087.442l-6.915,4.631a10.486,10.486,0,0,1-5.1,2.292c-3.361.659-8.908,1.989-8.964,2l-.027,0L64.671-15.2,51.528-13.066l-1.206.177a3.992,3.992,0,0,1-2.017.653,9.3,9.3,0,0,1-1.234.1h0ZM49.91-13.368Z",
    transform: "translate(-25.631 27.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5464",
    "data-name": "Path 5464",
    d: "M87.613,90.77a.32.32,0,0,1-.3-.221l-2-6.174a.319.319,0,1,1,.606-.2l2,6.174a.319.319,0,0,1-.3.416Z",
    transform: "translate(-64.8 -69.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5465",
    "data-name": "Path 5465",
    d: "M-68.57,144.886a.319.319,0,0,1-.3-.216.318.318,0,0,1,.2-.4L-50.133,138l3.37-3.975a.318.318,0,0,1,.217-.111.318.318,0,0,1,.232.075.318.318,0,0,1,.111.217.318.318,0,0,1-.075.232l-3.427,4.042a.328.328,0,0,1-.14.1l-18.62,6.3a.307.307,0,0,1-.1.01Z",
    transform: "translate(69.335 -112.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5466",
    "data-name": "Path 5466",
    d: "M-70.279,288.17a.318.318,0,0,1-.269-.148.32.32,0,0,1,.1-.44c.072-.046,7.226-4.585,8.879-6.238,1.684-1.684,7.818-6.483,8.131-6.728.287-.239,5.894-4.885,9.022-6.323,3.091-1.42,12.863-7.039,12.962-7.1a.318.318,0,0,1,.428.107c.139.22,3.41,5.4,3.921,6.443.5,1.02,2.25,4.389,2.268,4.423a.319.319,0,0,1-.137.429.319.319,0,0,1-.429-.137c-.018-.034-1.769-3.41-2.273-4.436-.433-.879-3.043-5.042-3.726-6.127-1.6.914-9.919,5.67-12.748,6.97-3.067,1.409-8.827,6.188-8.884,6.236l-.008.007c-.064.049-6.413,5.015-8.077,6.68-1.7,1.7-8.692,6.137-8.988,6.325a.316.316,0,0,1-.17.049Z",
    transform: "translate(70.821 -223.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5467",
    "data-name": "Path 5467",
    d: "M167.507,336.613a.318.318,0,0,1-.16-.593l17.87-10.355a.317.317,0,0,1,.215-.038l7.746,1.358a.318.318,0,1,1-.109.627l-7.632-1.338-17.77,10.3a.323.323,0,0,1-.159.043h0Z",
    transform: "translate(-136.039 -279.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5468",
    "data-name": "Path 5468",
    d: "M306.437,310.67a.319.319,0,0,1-.308-.238c-.007-.027-.679-2.614-.908-3.372a9.093,9.093,0,0,0-2.947,1.156l-1.951,1.286a.319.319,0,0,1-.469-.142l-.711-1.676a.315.315,0,0,1,0-.243.322.322,0,0,1,.172-.174l1.847-.78a.319.319,0,0,1,.384.108l.666.935c.261-.134.7-.352,1.172-.561,1.419-.623,1.878-.589,2.121-.49a.52.52,0,0,1,.308.328c.212.679.906,3.352.936,3.465a.318.318,0,0,1-.228.388.342.342,0,0,1-.081.01h0Zm-6.583-2.939.437,1.031,1.368-.9-.488-.685-1.318.557h0Z",
    transform: "translate(-250.81 -262.934)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5469",
    "data-name": "Path 5469",
    d: "M242.908,257.747a.319.319,0,0,1-.276-.159l-2.1-3.627-1.939-3.242-.005-.009a11.08,11.08,0,0,0-1.242-1.9c-.548.046-2.531.008-3.166-.007a.318.318,0,1,1,.014-.636c1.385.03,2.934.042,3.128.007s.531-.112,1.82,2.223l1.939,3.242,2.1,3.631a.317.317,0,0,1-.116.434.324.324,0,0,1-.159.043h0Z",
    transform: "translate(-194.048 -212.252)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5470",
    "data-name": "Path 5470",
    d: "M15.692-17.766a.1.1,0,0,1-.092-.072l-.815-3.129-1.324.239a.1.1,0,0,1-.108-.064L12.206-24.2a.1.1,0,0,1,.06-.121.1.1,0,0,1,.121.06l1.12,3.332,1.33-.239a.1.1,0,0,1,.109.07l.838,3.215a.1.1,0,0,1-.069.117.076.076,0,0,1-.025,0Z",
    transform: "translate(-1.209 24.801)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5471",
    "data-name": "Path 5471",
    d: "M15.535,15.082a.093.093,0,0,1-.091-.068c-.118-.39-.385-1.048-.6-1.151a.566.566,0,0,0-.45-.062.1.1,0,0,1-.133-.062,3.271,3.271,0,0,1-.109-.728.1.1,0,1,1,.19.008,2.679,2.679,0,0,0,.081.58.865.865,0,0,1,.5.094c.356.173.663,1.156.7,1.268a.085.085,0,0,1-.091.12h0Z",
    transform: "translate(-2.909 -7.602)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5472",
    "data-name": "Path 5472",
    d: "M-5.091-13.931a.1.1,0,0,1-.046-.012c-.049-.027-.1-.057-.731-1.757-.3-.825-.6-1.65-.6-1.66l-2.29-7.707a.1.1,0,0,1,.064-.118.1.1,0,0,1,.118.064l2.289,7.7c.425,1.2,1.139,3.151,1.258,3.319a.1.1,0,0,1,.021.118.1.1,0,0,1-.085.049h0ZM-5.045-14.11Z",
    transform: "translate(17.028 25.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5473",
    "data-name": "Path 5473",
    d: "M-47.624,38.029a.094.094,0,0,1-.091-.069.1.1,0,0,1,.065-.118l10.154-2.98,13.337-3.847a.1.1,0,0,1,.118.065.1.1,0,0,1-.065.118l-13.337,3.847L-47.6,38.025a.1.1,0,0,1-.024,0Z",
    transform: "translate(50.917 -23.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5474",
    "data-name": "Path 5474",
    d: "M123.871,6.557a.1.1,0,0,1-.092-.072l-1-3.789a.1.1,0,0,1,.185-.049l1,3.789a.1.1,0,0,1-.068.117.08.08,0,0,1-.025,0h0Z",
    transform: "translate(-97.403 1.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5475",
    "data-name": "Path 5475",
    d: "M147.984,18.274a.1.1,0,0,1-.083-.049l-.86-1.539-2.1-4.034L143.177,9.17l-1.961-3.605-.005-.01c-.014-.035-1.412-3.548-1.622-4.029-.155-.355-.951-1.537-1.347-2.119-.228.146-.453.274-.566.338l-.021.009L133.634.919a.1.1,0,1,1-.053-.183l4.011-1.163c.183-.1.372-.216.541-.325l-.109-.159c-.069-.059-.494-.428-.9-.826-.826-.8-.884-1.043-.834-1.169.135-.333,1.225-.792,1.442-.88a.1.1,0,0,1,.121.046,9.907,9.907,0,0,1,1.052,2.6,1.653,1.653,0,0,1-.5.441,24.7,24.7,0,0,1,1.363,2.147c.207.475,1.561,3.873,1.622,4.029l1.96,3.6,1.762,3.483,2.1,4.03.858,1.536a.095.095,0,0,1-.083.142h0ZM137.721-3.573a3.6,3.6,0,0,0-1.256.741,7.116,7.116,0,0,0,1.692,1.786.112.112,0,0,1,.017.018l.12.173a1.726,1.726,0,0,0,.434-.354A13.241,13.241,0,0,0,137.721-3.573ZM138.728-1.206Z",
    transform: "translate(-106.742 6.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M188.891,5.844a.1.1,0,0,1-.088-.059,12.421,12.421,0,0,0-2.381-3.309.1.1,0,0,1-.02-.027l-4.733-9.931-3.375-7.833-2.98-7.266a.1.1,0,0,1,.052-.125.1.1,0,0,1,.125.052l2.978,7.264,3.374,7.829,4.724,9.913a12.578,12.578,0,0,1,2.413,3.359.1.1,0,0,1-.052.125.092.092,0,0,1-.036.008Z",
    transform: "translate(-143.102 23.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M284.789,208.64a.1.1,0,0,1-.086-.053l-1.077-2.154c-.684.438-2.368,1.553-3.327,2.19a.1.1,0,1,1-.107-.159c.118-.078,2.491-1.656,3.346-2.2l-1.363-2.726a18.664,18.664,0,0,1-1.057-2.493c-.165-.693-2.081-4.726-2.1-4.767a.1.1,0,1,1,.173-.082c.079.166,1.943,4.092,2.113,4.8a18.918,18.918,0,0,0,1.043,2.452l1.354,2.709c.065-.04.111-.068.13-.078a12.731,12.731,0,0,1,1.751-.3.1.1,0,0,1,.105.079l.382,2.292a.1.1,0,0,1-.066.107l-1.189.372a.108.108,0,0,1-.029,0h0Zm-1-2.307,1.05,2.1,1.031-.323-.354-2.12a11.473,11.473,0,0,0-1.6.267C283.9,206.264,283.855,206.291,283.789,206.333Z",
    transform: "translate(-233.318 -166.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M306.814,255.867a.1.1,0,0,1-.034-.185l1.2-.467a.1.1,0,1,1,.069.178l-1.2.467a.113.113,0,0,1-.035.007Z",
    transform: "translate(-257.423 -218.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M279.566,262.784a.091.091,0,0,1-.081-.046.1.1,0,0,1,.031-.131l3.644-2.262a.1.1,0,0,1,.1.163l-3.644,2.262a.1.1,0,0,1-.05.014Z",
    transform: "translate(-233.719 -222.836)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M285.237,249.318a.1.1,0,0,1-.083-.048l-2.738-4.764a.1.1,0,0,1,.165-.095l2.738,4.764a.1.1,0,0,1-.035.13.092.092,0,0,1-.048.013Z",
    transform: "translate(-236.27 -208.946)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M261.772,241.84a.1.1,0,0,1-.024-.189l4.716-1.232a.1.1,0,1,1,.049.185l-4.716,1.232a.076.076,0,0,1-.025,0h0Z",
    transform: "translate(-218.239 -205.512)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M246.446,200.762a.1.1,0,0,1-.086-.055l-3-6.2-2.5,1.842a.1.1,0,1,1-.114-.153l2.589-1.909a.1.1,0,0,1,.079-.016.094.094,0,0,1,.062.051l3.045,6.3a.1.1,0,0,1-.044.127.092.092,0,0,1-.042.009h0Z",
    transform: "translate(-200.005 -165.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M204.284,155.894a.1.1,0,0,1-.082-.047,28.261,28.261,0,0,1-1.343-2.487,10.581,10.581,0,0,0-1.5-1.964l-.008-.009-2.971-4.064-.008-.013c-.042-.079-1.009-1.943-1.051-2.028a.1.1,0,0,1,.172-.086c.04.081.982,1.9,1.047,2.018l2.963,4.054a10.324,10.324,0,0,1,1.533,2.021c.238.622,1.319,2.439,1.329,2.458a.1.1,0,0,1-.083.144h0Z",
    transform: "translate(-162.247 -122.63)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M182.59,140.641a.094.094,0,0,1-.082-.047c-.065-.112-1.6-2.742-1.731-2.98-.108-.2-.456-.964-.571-1.215l-.278.1h-.014c-.606.113-5.256,2.377-5.3,2.4a.1.1,0,0,1-.083-.172c.191-.094,4.683-2.281,5.343-2.414l.354-.125a.094.094,0,0,1,.118.051c.005.01.477,1.051.6,1.284s1.712,2.946,1.727,2.973a.1.1,0,0,1-.034.13.092.092,0,0,1-.048.013h0Z",
    transform: "translate(-142.377 -114.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M228.819,160.055a.1.1,0,0,1-.049-.177l3.4-2.071a.1.1,0,0,1,.1.164l-3.4,2.071a.1.1,0,0,1-.049.014h0Z",
    transform: "translate(-189.571 -133.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M210.978,143.062a.073.073,0,0,1-.029,0,.1.1,0,0,1-.057-.048l-1.734-3.37a.1.1,0,0,1,.171-.087l1.689,3.283,1.059-.572a.1.1,0,0,1,.09.169l-1.145.619a.1.1,0,0,1-.046.012h0Z",
    transform: "translate(-172.541 -117.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M178.334,79.408a.1.1,0,0,1-.088-.059c-.018-.043-1.835-4.348-2.024-4.756s-1.539-4.53-1.6-4.705a.1.1,0,0,1,.182-.06c.014.043,1.4,4.28,1.588,4.685s1.951,4.585,2.026,4.761a.1.1,0,0,1-.051.125.092.092,0,0,1-.036.008h0Z",
    transform: "translate(-142.506 -57.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M104.155,90.157a.1.1,0,0,1-.088-.059.093.093,0,0,1,.051-.125l15.067-6.456a.1.1,0,1,1,.074.176l-15.067,6.456a.093.093,0,0,1-.038.008Z",
    transform: "translate(-81.12 -69.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M89.785-11.7a.1.1,0,0,1-.092-.072l-1.847-6.981-1.74-6.312a.094.094,0,0,1,.008-.072.094.094,0,0,1,.058-.045.094.094,0,0,1,.072.008.094.094,0,0,1,.045.058L88.03-18.8l1.847,6.983a.1.1,0,0,1-.068.117.08.08,0,0,1-.025,0Z",
    transform: "translate(-65.499 25.548)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M81.638,19.088a.095.095,0,0,1-.024-.187l5.644-1.535a.1.1,0,1,1,.049.185l-5.644,1.535a.082.082,0,0,1-.025,0h0Z",
    transform: "translate(-61.532 -11.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M314.011,406.2H314a.1.1,0,0,1-.087-.1c.208-2.5,1.118-7.213,1.806-8.073a3.959,3.959,0,0,0,.4-2.406c-.009-.224-.016-.416-.009-.563a30.805,30.805,0,0,0-1.1-5.215,20.879,20.879,0,0,0-3.28-2.691.1.1,0,0,1,.111-.155,21.883,21.883,0,0,1,3.341,2.762,30,30,0,0,1,1.124,5.31c-.007.139,0,.328.009.546a4.071,4.071,0,0,1-.444,2.532c-.611.765-1.542,5.282-1.766,7.97a.1.1,0,0,1-.095.087Z",
    transform: "translate(-261.748 -333.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5492",
    "data-name": "Path 5492",
    d: "M123.726,335.621a.1.1,0,0,1-.081-.043l-6.91-10.61a.1.1,0,0,1,.16-.105l6.91,10.61a.1.1,0,0,1-.027.133.094.094,0,0,1-.052.016Z",
    transform: "translate(-92.135 -278.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5493",
    "data-name": "Path 5493",
    d: "M35.472,69.976a.095.095,0,0,1-.087-.134,2.737,2.737,0,0,0,.009-2.3,1.3,1.3,0,0,0-1.483-.554.089.089,0,0,1-.124-.059l-2.085-6.9a.1.1,0,1,1,.183-.056l2.058,6.812a1.489,1.489,0,0,1,1.608.652,2.868,2.868,0,0,1,.009,2.489.1.1,0,0,1-.087.056h0Z",
    transform: "translate(-18.17 -48.471)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5494",
    "data-name": "Path 5494",
    d: "M-68.8,88.938a.1.1,0,0,1-.094-.077.1.1,0,0,1,.075-.112l20.276-4.042a.1.1,0,0,1,.112.075.1.1,0,0,1-.075.112l-20.275,4.042h-.02Z",
    transform: "translate(69.339 -70.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5495",
    "data-name": "Path 5495",
    d: "M61.529,61.165a.1.1,0,0,1-.094-.079,15.06,15.06,0,0,0-.946-2.367A9.2,9.2,0,0,1,59.9,57.3a22.16,22.16,0,0,0-1.641-2.926.1.1,0,0,1,.161-.1,23.372,23.372,0,0,1,1.669,3,10.493,10.493,0,0,0,.568,1.364,14.959,14.959,0,0,1,.96,2.414.1.1,0,0,1-.078.111h-.017Z",
    transform: "translate(-41.269 -43.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5496",
    "data-name": "Path 5496",
    d: "M59.937,107.564a.1.1,0,0,1-.031-.186c.13-.044,3.2-1.072,4.3-.895a.1.1,0,0,1-.03.189c-1.047-.169-4.172.877-4.2.887a.085.085,0,0,1-.03.005Z",
    transform: "translate(-42.653 -88.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5497",
    "data-name": "Path 5497",
    d: "M68.508,31.7a.1.1,0,0,1-.092-.07.094.094,0,0,1,.066-.117l7.118-2a.915.915,0,0,1,.646-.54c.31-.038,8.008-2.017,12.035-3.059a.1.1,0,1,1,.047.185c-.476.124-11.661,3.016-12.06,3.063-.338.04-.51.462-.511.466a.093.093,0,0,1-.062.056l-7.162,2.005a.09.09,0,0,1-.026,0h0Z",
    transform: "translate(-50.11 -18.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5498",
    "data-name": "Path 5498",
    d: "M191.747-15.723a.1.1,0,0,1-.088-.06l-3.8-9.278a.1.1,0,0,1,.052-.125.1.1,0,0,1,.125.052l3.8,9.278a.1.1,0,0,1-.052.125.092.092,0,0,1-.036.008Z",
    transform: "translate(-154.011 25.553)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5499",
    "data-name": "Path 5499",
    d: "M190.319-6.928a.1.1,0,0,1-.086-.053.1.1,0,0,1,.043-.127l4.591-2.264a.1.1,0,0,1,.116.025l.26.311,1.963-.8-1.159-4.21c-.189-.464-3.932-9.694-4.011-9.949a5.329,5.329,0,0,0-1-1,.1.1,0,0,1-.012-.134.1.1,0,0,1,.134-.012,5.267,5.267,0,0,1,1.065,1.1c.062.2,2.649,6.589,4.008,9.94v.01l1.184,4.3a.1.1,0,0,1-.056.113l-2.106.86a.1.1,0,0,1-.109-.027l-.256-.307-4.523,2.232a.1.1,0,0,1-.042.01Z",
    transform: "translate(-156.079 25.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5500",
    "data-name": "Path 5500",
    d: "M249.521,91.51a.1.1,0,0,1-.061-.022c-.178-.151-3.536-7.956-4.562-10.343l-2.227-5.284-1.35.42a.1.1,0,1,1-.057-.182l1.432-.446a.1.1,0,0,1,.116.055l2.26,5.364c1.714,3.994,4.328,10.017,4.517,10.278a.094.094,0,0,1,0,.127.1.1,0,0,1-.073.034h0ZM249.583,91.342Z",
    transform: "translate(-200.423 -62.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5501",
    "data-name": "Path 5501",
    d: "M265.769,135.757a.1.1,0,0,1-.049-.177l9.39-5.7a.1.1,0,1,1,.1.164l-9.39,5.7a.1.1,0,0,1-.049.014h0Z",
    transform: "translate(-221.716 -109.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M274.112,82.641a.1.1,0,0,1-.088-.059l-4.1-9.679h-.008a.8.8,0,0,1-.713-.4c-.241-.416-.917-2.229-.946-2.306a.1.1,0,0,1,.033-.111c.226-.168,2.229-1.621,2.9-1.047a7.218,7.218,0,0,1,1.208,2.61.1.1,0,0,1-.048.109L270.2,72.873a.091.091,0,0,1-.086,0l4.077,9.633a.1.1,0,0,1-.051.125.093.093,0,0,1-.038.008h0Zm-4.124-9.931a.067.067,0,0,0,.132-.005l2.08-1.078a6.79,6.79,0,0,0-1.126-2.441c-.46-.391-1.986.561-2.609,1.012.127.339.7,1.852.906,2.21a.625.625,0,0,0,.6.3h.013Z",
    transform: "translate(-223.962 -56.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M300.913,101.664a.094.094,0,0,1-.087-.057l-4.17-9.558a.1.1,0,0,1,.049-.126.094.094,0,0,1,.126.049L301,101.53a.1.1,0,0,1-.087.134Z",
    transform: "translate(-248.662 -76.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M292.7,118.544a.1.1,0,0,1-.04-.182l1.862-.86a.1.1,0,1,1,.079.173l-1.862.86a.087.087,0,0,1-.04.009Z",
    transform: "translate(-245.143 -98.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M293.669,154.91a.1.1,0,0,1-.048-.178l3.915-2.266a.1.1,0,0,1,.1.165l-3.915,2.266a.092.092,0,0,1-.048.013Z",
    transform: "translate(-245.987 -128.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M336.991,110.353a.1.1,0,0,1-.044-.179l2.1-1.1a.1.1,0,0,1,.088.169l-2.1,1.1a.092.092,0,0,1-.044.01Z",
    transform: "translate(-283.674 -91.244)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M349.485,100.914a.1.1,0,0,1-.086-.052L347.552,97.2a.1.1,0,1,1,.17-.087l1.847,3.661a.1.1,0,0,1-.084.14Z",
    transform: "translate(-292.936 -80.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M357.3,79.515a.1.1,0,0,1-.077-.154l2.359-3.14.394-2.333a.1.1,0,1,1,.189.033l-.4,2.355a.1.1,0,0,1-.018.042l-2.374,3.158a.094.094,0,0,1-.077.038h0Z",
    transform: "translate(-301.344 -60.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M329.411,76.238a.1.1,0,0,1-.078-.04.094.094,0,0,1,.023-.133l3.151-2.228a.091.091,0,0,1,.055-.017h4.95a.095.095,0,1,1,0,.19h-4.919l-3.127,2.211a.1.1,0,0,1-.055.017Z",
    transform: "translate(-277.081 -60.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M337.1,22.883a.1.1,0,0,1-.094-.077l-.1-.533a.1.1,0,0,1,.049-.1,14.279,14.279,0,0,1,2.463-1.094,7.868,7.868,0,0,0,1.853-.708c.328-.156,1.4-.756,1.411-.761a.1.1,0,1,1,.094.166c-.044.025-1.089.609-1.422.767a8.169,8.169,0,0,1-1.935.726,13.452,13.452,0,0,0-2.312,1.038l.09.463a.1.1,0,0,1-.075.112H337.1Z",
    transform: "translate(-283.676 -13.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M275.49,10.206a.1.1,0,0,1-.1-.082,2.573,2.573,0,0,1,0-.752,1.1,1.1,0,0,1,.849-.756c.434-.109,3.837-1.448,3.872-1.461l7.767-2.977a.1.1,0,0,1,.069.179l-7.767,2.976c-.14.055-3.448,1.356-3.894,1.467a.929.929,0,0,0-.71.614,2.381,2.381,0,0,0,0,.68.1.1,0,0,1-.081.108h-.013Z",
    transform: "translate(-230.148 0.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M313.3-19.369a.1.1,0,0,1-.094-.077,9,9,0,0,0-.627-1.13,7.4,7.4,0,0,1-.382-.667c-.056-.147-1.35-2.355-2.206-3.8a.1.1,0,0,1,.034-.131.1.1,0,0,1,.131.034c.219.371,2.139,3.626,2.219,3.834.029.074.2.36.368.637a7.214,7.214,0,0,1,.65,1.191.1.1,0,0,1-.074.113Z",
    transform: "translate(-260.256 25.554)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M306.029-15.223a.1.1,0,0,1-.081-.044.1.1,0,0,1,.029-.131l6.892-4.393a.1.1,0,0,1,.131.029.1.1,0,0,1-.029.131l-6.892,4.393a.093.093,0,0,1-.05.015Z",
    transform: "translate(-256.739 20.867)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M295.138-22.372a.1.1,0,0,1-.081-.043l-2.909-4.474a.1.1,0,0,1,.029-.133.1.1,0,0,1,.133.029l2.909,4.474a.1.1,0,0,1-.029.133.094.094,0,0,1-.052.016h0Z",
    transform: "translate(-244.734 27.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M361.945,12.57a.1.1,0,0,1-.073-.033c-.427-.493-1.97-3.2-2.037-3.311a.1.1,0,1,1,.165-.1c.016.029,1.6,2.8,2.015,3.281a.1.1,0,0,1-.072.159h0Z",
    transform: "translate(-303.621 -4.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M375.494-22.989a.1.1,0,0,1-.088-.061.1.1,0,0,1,.055-.124,25.026,25.026,0,0,0,4.663-2.318,10.883,10.883,0,0,1,2.53-1.54.1.1,0,0,1,.125.052.1.1,0,0,1-.052.125,10.651,10.651,0,0,0-2.479,1.507A24.555,24.555,0,0,1,375.528-23a.111.111,0,0,1-.035.007h0Z",
    transform: "translate(-317.17 27.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M435-22.444a.1.1,0,0,1-.086-.053,33.5,33.5,0,0,0-2.7-3.588.1.1,0,0,1,.012-.134.1.1,0,0,1,.134.012,32.915,32.915,0,0,1,2.729,3.626.1.1,0,0,1-.043.129.1.1,0,0,1-.043.01h0Z",
    transform: "translate(-366.574 26.465)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M404-8.112a.1.1,0,0,1-.085-.051l-.849-1.623a.1.1,0,0,1,.031-.124l5.146-3.482a.1.1,0,0,1,.133.026.1.1,0,0,1-.026.133L403.277-9.8l.81,1.548a.1.1,0,0,1-.04.129.092.092,0,0,1-.047.011Z",
    transform: "translate(-341.232 15.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M406.045-15.342a.1.1,0,0,1-.079-.042l-.909-1.321a.1.1,0,0,1,.025-.133.1.1,0,0,1,.133.025l.857,1.245,3.28-2.146a.1.1,0,0,1,.133.027.1.1,0,0,1-.027.133l-3.359,2.2a.094.094,0,0,1-.054.012Z",
    transform: "translate(-342.956 19.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M393.375.658a.1.1,0,0,1-.091-.065,1.77,1.77,0,0,0-.83-1.184l-.038-.023a.618.618,0,0,1-.265-.642.1.1,0,0,1,.047-.062l.935-.511L392.3-3.387a.1.1,0,0,1,.039-.129.1.1,0,0,1,.129.039l.875,1.64a.1.1,0,0,1-.039.129l-.977.535a.413.413,0,0,0,.186.4l.036.023a1.943,1.943,0,0,1,.91,1.285.1.1,0,0,1-.06.121.085.085,0,0,1-.03.005h0Z",
    transform: "translate(-331.733 6.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M386.557,1.363a.1.1,0,0,1-.087-.057l-.862-2a.1.1,0,0,1,.049-.125.094.094,0,0,1,.073,0,.094.094,0,0,1,.052.051l.861,2a.1.1,0,0,1-.049.125.093.093,0,0,1-.038.008h0Z",
    transform: "translate(-326.045 4.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M361.845,69.12a.1.1,0,0,1,0-.191,21.3,21.3,0,0,0,3.08-.3,34.009,34.009,0,0,0,8.732-6.581l.005,0c.317-.282.825-.817.839-1.051a.274.274,0,0,1,.122-.221.853.853,0,0,1,.606-.018,1.029,1.029,0,0,1,.32-.715c.077-.073.226-.207.415-.377a21.466,21.466,0,0,0,1.917-1.848,4.538,4.538,0,0,1,.354-.58,4.043,4.043,0,0,0,.5-.871,1.5,1.5,0,0,0,0-.264.564.564,0,0,1,.131-.52c.038-.031.312-.336.631-.689,2.132-2.363,4.179-4.566,4.715-4.689a.1.1,0,0,1,.043.186c-.55.126-3.5,3.4-4.616,4.63-.42.466-.607.672-.65.709-.078.064-.074.178-.062.36a1.521,1.521,0,0,1,0,.3,3.437,3.437,0,0,1-.531.955,4.893,4.893,0,0,0-.336.545,14.748,14.748,0,0,1-1.966,1.92c-.189.17-.337.3-.412.375a.847.847,0,0,0-.258.692.1.1,0,0,1-.125.1.883.883,0,0,0-.568-.042.086.086,0,0,0-.038.074c-.022.385-.8,1.087-.9,1.18a34.21,34.21,0,0,1-8.814,6.63,20.856,20.856,0,0,1-3.127.311h0Z",
    transform: "translate(-305.296 -40.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M475.188,48.383a.1.1,0,0,1-.075-.155c1.247-1.57,3.13-3.952,3.207-4.084a9.444,9.444,0,0,1,1.1-.992.1.1,0,0,1,.1-.014.094.094,0,0,1,.057.079.079.079,0,0,0,.007.023.327.327,0,0,0,.118-.085c.269-.258,2.4-1.63,2.487-1.688a.1.1,0,1,1,.1.16c-.761.49-2.254,1.468-2.458,1.665-.047.044-.187.179-.321.129a.177.177,0,0,1-.066-.046,8.872,8.872,0,0,0-.953.86c-.1.172-2.9,3.705-3.223,4.109a.1.1,0,0,1-.075.036h0Z",
    transform: "translate(-403.897 -32.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M446.466,43.323a.094.094,0,0,1-.052-.016c-.363-.235-8.888-5.767-9.268-6.052a7.876,7.876,0,0,1-.86-.8l-6.3-7.023a.1.1,0,0,1-.018-.03l-1.275-3.417a.1.1,0,1,1,.178-.066l1.268,3.4,6.291,7.009a7.939,7.939,0,0,0,.834.779c.375.281,9.169,5.987,9.257,6.044a.1.1,0,0,1,.029.133.094.094,0,0,1-.081.043h0Z",
    transform: "translate(-363.525 -18.855)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M483.327,158.837a.1.1,0,0,1-.078-.04l-2.154-3.063a.1.1,0,0,1,.018-.129l4.7-3.808,1.706-1.457,1.817-3.664a.1.1,0,1,1,.17.085l-1.825,3.682a.088.088,0,0,1-.023.03l-1.723,1.471L481.3,155.7l2.1,2.989a.095.095,0,0,1-.078.15h0Z",
    transform: "translate(-409.105 -123.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M497.811,172.54a.1.1,0,0,1-.082-.047l-1.888-3.13a.1.1,0,0,1,.03-.129l4.774-3.1,1.477-.925L497.7,162.3a.1.1,0,0,1,.105-.16l4.542,2.993a.1.1,0,0,1,.043.081.093.093,0,0,1-.044.079l-1.6,1-4.7,3.052,1.84,3.051a.1.1,0,0,1-.082.145h0Z",
    transform: "translate(-421.936 -137.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M372.545,205.375a.1.1,0,0,1-.079-.043c-.023-.035-2.3-3.509-3.311-5.072a6.9,6.9,0,0,0-1.609-1.93l-4.992-1.986-3.214,1.624a.1.1,0,1,1-.087-.17l3.251-1.644a.1.1,0,0,1,.078,0l5.04,2.005.014.008a6.635,6.635,0,0,1,1.675,1.992c1.007,1.562,3.287,5.036,3.31,5.071a.1.1,0,0,1-.027.133.094.094,0,0,1-.052.016Z",
    transform: "translate(-303.08 -166.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M437.829,208.184a.1.1,0,0,1-.052-.176l4.738-3.071a.1.1,0,0,1,.131.027l1.035,1.587a.1.1,0,1,1-.16.1l-.983-1.506-4.657,3.019a.094.094,0,0,1-.052.016h0Z",
    transform: "translate(-371.398 -174.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M387.66,194.222a.1.1,0,0,1-.013-.19l3.733-.49,4.708-3.328a.1.1,0,0,1,.109.156l-4.726,3.342a.1.1,0,0,1-.043.017l-3.756.493Z",
    transform: "translate(-327.754 -161.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M411.15,223.026a.1.1,0,0,1-.094-.079l-.916-5.236a.1.1,0,0,1,.189-.033l.916,5.236a.1.1,0,0,1-.078.111Z",
    transform: "translate(-347.392 -185.662)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M416.632,237.334a.094.094,0,0,1-.088-.06l-.155-.382-1.428.242a.1.1,0,1,1-.033-.189l1.5-.255a.1.1,0,0,1,.1.059l.183.454a.1.1,0,0,1-.053.125.084.084,0,0,1-.035.007Z",
    transform: "translate(-351.49 -202.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M396.861,245.665h-6.466a.1.1,0,1,1,0-.19h6.444a.385.385,0,0,0,.164-.492,14.56,14.56,0,0,0-1.29-2,.094.094,0,0,1-.017-.074.1.1,0,0,1,.042-.064l1.645-1.082a.1.1,0,0,1,.106.16l-1.561,1.027a12.828,12.828,0,0,1,1.26,1.974.575.575,0,0,1-.287.731.094.094,0,0,1-.038.008h0Z",
    transform: "translate(-330.133 -206.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M409.506,254.527a.094.094,0,0,1-.1-.094,12.436,12.436,0,0,1,.168-2.753c.185-.25,2.6-1.861,2.872-2.044a.1.1,0,1,1,.107.159c-1.026.684-2.7,1.83-2.824,2a12.614,12.614,0,0,0-.13,2.638.1.1,0,0,1-.094.1Z",
    transform: "translate(-346.757 -213.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5534",
    "data-name": "Path 5534",
    d: "M401.933,149.42a.1.1,0,0,1-.068-.163,12.154,12.154,0,0,1,1.568-1.416,2.541,2.541,0,0,1,.329-.113,3.01,3.01,0,0,0,.662-.271,9.312,9.312,0,0,0,1.611-1.255c.307-.317,5.605-4.881,5.832-5.075a.1.1,0,1,1,.125.146c-.055.048-5.517,4.751-5.819,5.063a9.473,9.473,0,0,1-1.657,1.29,3.2,3.2,0,0,1-.7.286,2.353,2.353,0,0,0-.308.107A11.41,11.41,0,0,0,402,149.392a.094.094,0,0,1-.069.029h0Z",
    transform: "translate(-340.17 -119.116)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5535",
    "data-name": "Path 5535",
    d: "M410.728,77.661h-.017c-.376-.066-1.454-1.3-1.666-1.549l-2.534-2.881c-.131-.116-1.992-1.749-2.185-2.013s-1.052-1.805-1.089-1.87a.1.1,0,1,1,.166-.094c.009.016.891,1.6,1.076,1.851.152.208,1.611,1.5,2.162,1.986l.009.009,2.539,2.886a7.287,7.287,0,0,0,1.555,1.487.1.1,0,0,1-.016.19h0Z",
    transform: "translate(-341.378 -56.569)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5536",
    "data-name": "Path 5536",
    d: "M470.136,136.346a.1.1,0,0,1-.094-.077,6.236,6.236,0,0,0-1.617-2.072c-.3-.3-.58-.584-.771-.814a20.836,20.836,0,0,0-2.623-2.169.1.1,0,0,1,.111-.155,20.334,20.334,0,0,1,2.66,2.2c.186.224.464.5.76.8a6.129,6.129,0,0,1,1.669,2.169.1.1,0,0,1-.074.113Z",
    transform: "translate(-395.11 -110.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5537",
    "data-name": "Path 5537",
    d: "M-59.5,269.979a.1.1,0,0,1-.072-.033c-.113-.13-2.775-3.192-2.926-3.428a11.4,11.4,0,0,0-1.493-1.752,24.512,24.512,0,0,0-3.625,2.9l-.277.241a8.6,8.6,0,0,1-1.258.892.1.1,0,0,1-.13-.036.1.1,0,0,1,.036-.13,8.483,8.483,0,0,0,1.225-.87l.277-.241c2.935-2.554,3.619-3.012,3.809-2.939a10.118,10.118,0,0,1,1.6,1.831c.118.186,2.141,2.522,2.909,3.4a.1.1,0,0,1-.009.135.1.1,0,0,1-.062.023h0Z",
    transform: "translate(69.687 -226.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5538",
    "data-name": "Path 5538",
    d: "M-53.032,303.154a.094.094,0,0,1-.074-.035l-4.2-5.178a.093.093,0,0,1-.014-.1l.854-2.2a11.781,11.781,0,0,0-.747-1.16,2.628,2.628,0,0,0-.948-.8c-.589.467-5.885,4.661-6.34,4.868a17.656,17.656,0,0,1-2.094.515c-1.78.367-1.826.317-1.866.273a.1.1,0,0,1-.021-.1c.008-.117-.152-.857-.281-1.454-.091-.424-.186-.862-.242-1.163-.147-.8-.674-3.251-.679-3.276a.1.1,0,0,1,.073-.113.1.1,0,0,1,.113.073c.005.025.532,2.483.68,3.281.055.3.15.735.241,1.158.2.9.268,1.268.282,1.433a31.412,31.412,0,0,0,3.716-.8c.36-.164,4.309-3.263,6.347-4.88a.1.1,0,0,1,.094-.014,2.691,2.691,0,0,1,1.082.892,11.453,11.453,0,0,1,.782,1.221.094.094,0,0,1,.005.079l-.849,2.188L-52.954,303a.094.094,0,0,1,.021.07.094.094,0,0,1-.035.064.1.1,0,0,1-.06.021ZM-68.479,299.225ZM-68.479,299.225Z",
    transform: "translate(70.03 -251.461)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5539",
    "data-name": "Path 5539",
    d: "M-69.2,334.266a.1.1,0,0,1-.094-.075.1.1,0,0,1,.074-.113l8.765-1.825a7.988,7.988,0,0,0,1.494-.93c.22-.156.307-.217.347-.238.121-.092,1.039-1.223,1.6-1.917a.1.1,0,0,1,.134-.016.1.1,0,0,1,.016.134c-.568.711-1.539,1.914-1.658,1.969-.029.014-.177.12-.321.222a7.081,7.081,0,0,1-1.566.961c-.4.085-8.681,1.808-8.765,1.825h-.02Zm10.592-3.185Z",
    transform: "translate(69.688 -282.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5540",
    "data-name": "Path 5540",
    d: "M-38.3,376.306a.1.1,0,0,1-.091-.066,10.914,10.914,0,0,0-2.327-3.125,6.63,6.63,0,0,0-1.808.355h-.007l-4.7,1.008a.1.1,0,0,1-.113-.073.1.1,0,0,1,.073-.113l4.7-1.007a5.3,5.3,0,0,1,1.966-.328,11,11,0,0,1,2.4,3.224.1.1,0,0,1-.062.12.106.106,0,0,1-.029,0h0Z",
    transform: "translate(50.593 -320.782)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5541",
    "data-name": "Path 5541",
    d: "M-5.6,376.3a.2.2,0,0,1-.052,0c-.053-.009-.178-.033-.378-.89a.1.1,0,0,1,.072-.114.1.1,0,0,1,.114.072,3.272,3.272,0,0,0,.243.747,4.425,4.425,0,0,0,.627-.1.1.1,0,0,1,.113.074.1.1,0,0,1-.074.113,4.729,4.729,0,0,1-.663.1h0ZM-5.593,376.118Z",
    transform: "translate(14.65 -322.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5542",
    "data-name": "Path 5542",
    d: "M7.743,354.744a.1.1,0,0,1-.069-.03l-4.12-4.345a.1.1,0,0,1,.139-.131l4.12,4.345a.094.094,0,0,1-.066.161Z",
    transform: "translate(6.337 -301.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5543",
    "data-name": "Path 5543",
    d: "M7.588,326.556a.093.093,0,0,1-.069-.03L1.545,320.21a.1.1,0,0,1-.026-.072.093.093,0,0,1,.034-.068l1.454-1.21a.1.1,0,1,1,.122.146l-1.376,1.145,5.9,6.243a.094.094,0,0,1-.065.161h0Z",
    transform: "translate(8.084 -273.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5544",
    "data-name": "Path 5544",
    d: "M-47.832,250.058a.1.1,0,0,1-.075-.036.1.1,0,0,1,.016-.134l5.756-4.572-.684-1.042a.09.09,0,0,1-.014-.065,9.7,9.7,0,0,1,.364-1.727.6.6,0,0,1,.394-.254,2.878,2.878,0,0,1,1.805.12,1.7,1.7,0,0,1,.577.732,1.486,1.486,0,0,0,.294.443c.209.181,2.236,2.186,2.272,2.686a7.3,7.3,0,0,1-.01,1.4c-.02.038-.062.075-.3.272a6.355,6.355,0,0,0-1.347,1.363.1.1,0,0,1-.129.043.1.1,0,0,1-.043-.129,6.424,6.424,0,0,1,1.4-1.424c.108-.09.221-.183.25-.215a9.607,9.607,0,0,0-.01-1.293,12.868,12.868,0,0,0-2.206-2.556,1.614,1.614,0,0,1-.338-.5,1.529,1.529,0,0,0-.509-.657,2.731,2.731,0,0,0-1.653-.1c-.208.06-.263.129-.276.155a9.117,9.117,0,0,0-.341,1.632l.713,1.085a.1.1,0,0,1-.021.127l-5.825,4.626a.093.093,0,0,1-.06.021h0ZM-37.3,247.51Z",
    transform: "translate(51.1 -207.011)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5545",
    "data-name": "Path 5545",
    d: "M.056,270.483a.1.1,0,0,1-.094-.074c-.217-.965-2.729-3.669-2.755-3.7a.1.1,0,0,1,.005-.135.1.1,0,0,1,.135.005c.1.113,2.573,2.769,2.8,3.785a.1.1,0,0,1-.073.114H.053Z",
    transform: "translate(11.857 -228.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5546",
    "data-name": "Path 5546",
    d: "M16.293,287.362a2.43,2.43,0,0,1-1.193-.241.1.1,0,0,1,.1-.164,2.711,2.711,0,0,0,1.549.189.1.1,0,1,1,.021.19A4.5,4.5,0,0,1,16.293,287.362Z",
    transform: "translate(-3.691 -245.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5547",
    "data-name": "Path 5547",
    d: "M-18.008,203.6a.1.1,0,0,1-.091-.066.1.1,0,0,1,.062-.12l1.358-.434-.339-1.539a.1.1,0,0,1,.064-.112c1.589-.525,5.791-1.942,6.135-2.184a.1.1,0,0,1,.133.023.1.1,0,0,1-.023.133c-.412.29-5.373,1.939-6.1,2.182l.341,1.539a.1.1,0,0,1-.064.112l-1.441.462A.11.11,0,0,1-18,203.6h0Z",
    transform: "translate(25.154 -169.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5548",
    "data-name": "Path 5548",
    d: "M7.387,189.38a.093.093,0,0,1-.038-.008.091.091,0,0,1-.053-.06l-.265-.845a.1.1,0,0,1,.182-.057l.233.744c.153-.064.5-.2,1.169-.406a3.178,3.178,0,0,0,1.631-.956,13.357,13.357,0,0,0-.58-2.618.1.1,0,1,1,.183-.053,10.976,10.976,0,0,1,.566,2.761,3.2,3.2,0,0,1-1.743,1.048,10.556,10.556,0,0,0-1.243.44.1.1,0,0,1-.043.01Z",
    transform: "translate(3.293 -157.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5549",
    "data-name": "Path 5549",
    d: "M34.357,163.138a.094.094,0,0,1-.082-.047l-2.753-4.643L26.638,161.2a.1.1,0,0,1-.127-.031L19.438,150.19a.1.1,0,1,1,.16-.1L26.621,161l4.888-2.757a.094.094,0,0,1,.129.035l2.764,4.661,3.634-.96a14.459,14.459,0,0,0,2.241-.613c.073-.051.921-.779,1.994-1.7,3.826-3.288,7.95-6.814,8.442-7.03a.1.1,0,0,1,.077.176c-.506.224-5.637,4.631-8.394,7-1.267,1.089-1.931,1.66-2.009,1.713a15.333,15.333,0,0,1-2.3.641l-3.7.977a.08.08,0,0,1-.025,0Z",
    transform: "translate(-7.492 -126.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5550",
    "data-name": "Path 5550",
    d: "M7.264,217.278a.1.1,0,0,1-.059-.17l4.668-3.666-1.2-1.354L6.1,215.474l.566.641a.1.1,0,0,1-.143.127l-.635-.719a.094.094,0,0,1-.023-.073.1.1,0,0,1,.038-.066l4.726-3.5a.1.1,0,0,1,.129.013l1.321,1.5a.095.095,0,0,1-.013.138l-4.748,3.729a.09.09,0,0,1-.059.021h0Z",
    transform: "translate(4.302 -180.674)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5551",
    "data-name": "Path 5551",
    d: "M-14.1,239.316a.093.093,0,0,1-.091-.068.1.1,0,0,1,.064-.12c.018,0,1.846-.561,2.747-.966a.1.1,0,0,1,.126.048.1.1,0,0,1-.048.126c-.913.411-2.752.97-2.77.975A.1.1,0,0,1-14.1,239.316Z",
    transform: "translate(21.752 -203.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5552",
    "data-name": "Path 5552",
    d: "M53.4,180.751a.1.1,0,0,1-.095-.086s-.033-.337-.1-.76a21.975,21.975,0,0,0-.821-2.237.1.1,0,0,1,.031-.113,21.644,21.644,0,0,0,1.939-1.589,2.883,2.883,0,0,1,.251-.268c.323-.32.763-.76.626-1.189-.2-.624-1.126-3.668-1.135-3.7a.1.1,0,1,1,.183-.056c.009.031.936,3.073,1.135,3.7.173.541-.337,1.047-.674,1.383a2.588,2.588,0,0,0-.233.248,21.083,21.083,0,0,1-1.917,1.581,19.059,19.059,0,0,1,.8,2.215c.064.427.1.766.1.769a.1.1,0,0,1-.086.1H53.4Z",
    transform: "translate(-36.165 -144.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5553",
    "data-name": "Path 5553",
    d: "M81.014,133.753a.093.093,0,0,1-.038-.008,2.078,2.078,0,0,1-.689-.494,10.853,10.853,0,0,1-.7-2.085.1.1,0,0,1,.185-.047,10.8,10.8,0,0,0,.661,2.011,1.884,1.884,0,0,0,.616.44.1.1,0,0,1,.049.126.094.094,0,0,1-.087.057h0Z",
    transform: "translate(-59.831 -110.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5554",
    "data-name": "Path 5554",
    d: "M91.1,158.475a.1.1,0,0,1-.06-.021.094.094,0,0,1-.014-.134c.012-.016,1.2-1.5,1.748-2.246a4.938,4.938,0,0,1,1.074-1.116.1.1,0,0,1,.108.157,4.883,4.883,0,0,0-1.027,1.07c-.546.747-1.741,2.238-1.753,2.253a.1.1,0,0,1-.074.036h0Z",
    transform: "translate(-69.763 -131.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5555",
    "data-name": "Path 5555",
    d: "M82.879,174.618a.1.1,0,0,1-.083-.049c-.884-1.613-2.224-4.043-2.319-4.184-.179-.174-1.823-1.861-2.818-2.882a.1.1,0,0,1,.135-.135c.758.778,2.742,2.813,2.816,2.881.017.013.055.04,2.351,4.227a.1.1,0,0,1-.083.142h0Z",
    transform: "translate(-58.13 -141.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5556",
    "data-name": "Path 5556",
    d: "M78.544,202.291a.095.095,0,0,1-.061-.168,23.334,23.334,0,0,1,3.415-2.457.1.1,0,1,1,.061.181A23.934,23.934,0,0,0,78.6,202.27a.1.1,0,0,1-.061.022h0Z",
    transform: "translate(-58.841 -170.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5557",
    "data-name": "Path 5557",
    d: "M98,213.048h-.01a.1.1,0,0,1-.066-.044l-3.716-6.1a.1.1,0,0,1,.164-.1l3.66,6.013a2.883,2.883,0,0,1,1.438-.529.1.1,0,0,1,.014.191,2.674,2.674,0,0,0-1.416.551.093.093,0,0,1-.062.023h0Z",
    transform: "translate(-72.538 -176.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5558",
    "data-name": "Path 5558",
    d: "M90.991,231.225a.065.065,0,0,1-.022,0,.094.094,0,0,1-.059-.043l-2.824-4.6a.1.1,0,1,1,.163-.1L91.023,231l1.726-1.061a.1.1,0,1,1,.1.163l-1.806,1.111a.1.1,0,0,1-.049.014h0Z",
    transform: "translate(-67.214 -193.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5559",
    "data-name": "Path 5559",
    d: "M107.479,189.976a.1.1,0,0,1-.049-.177l3.271-1.982a.1.1,0,1,1,.1.164l-3.271,1.982a.1.1,0,0,1-.049.014h0Z",
    transform: "translate(-84.012 -159.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5560",
    "data-name": "Path 5560",
    d: "M141.558,166.1a.1.1,0,0,1-.043-.181l1.481-.745,3.344-2.445a22.214,22.214,0,0,1,2.007-1.267c.518-.235,1.415-.687,1.424-.691a.1.1,0,1,1,.086.172c-.009.005-.909.458-1.431.7a22.748,22.748,0,0,0-1.974,1.249l-3.349,2.449-.013.008-1.488.749a.1.1,0,0,1-.043.01h0Z",
    transform: "translate(-113.659 -136.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5561",
    "data-name": "Path 5561",
    d: "M163.485,133.67a.093.093,0,0,1-.085-.052l-3.015-5.823a.1.1,0,1,1,.169-.088l3.015,5.823a.1.1,0,0,1-.04.129.089.089,0,0,1-.044.01h0Z",
    transform: "translate(-130.112 -107.416)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5562",
    "data-name": "Path 5562",
    d: "M182.312,140.606a.1.1,0,0,1-.087-.056l-.653-1.411a.1.1,0,1,1,.173-.079l.653,1.411a.1.1,0,0,1-.047.126.087.087,0,0,1-.04.009h0Z",
    transform: "translate(-148.545 -117.289)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6042",
    "data-name": "Group 6042",
    transform: "translate(13.73 38.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5563",
    "data-name": "Path 5563",
    d: "M34,272.32l7.128,9.546Z",
    transform: "translate(-33.903 -272.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5564",
    "data-name": "Path 5564",
    d: "M40.478,281.322a.1.1,0,0,1-.077-.039l-7.128-9.546a.1.1,0,0,1,.153-.114l7.128,9.546a.1.1,0,0,1-.077.153Z",
    transform: "translate(-33.254 -271.584)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5565",
    "data-name": "Path 5565",
    d: "M56.352,287.052a.094.094,0,0,1-.082-.047l-2.419-4.138-4.833-7.777-2.48,1.63a.1.1,0,0,1-.105-.16L49,274.875a.091.091,0,0,1,.073-.013.1.1,0,0,1,.061.043l4.886,7.862,2.42,4.14a.1.1,0,0,1-.034.13.093.093,0,0,1-.048.013h0Z",
    transform: "translate(-30.952 -235.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5566",
    "data-name": "Path 5566",
    d: "M113.909,274.366a.1.1,0,0,1-.047-.178l1.835-1.044-.1-.326a.1.1,0,0,1,.046-.112l18.5-10.021a.1.1,0,0,1,.091.169L115.8,272.838l.1.324a.1.1,0,0,1-.044.111l-1.9,1.082a.088.088,0,0,1-.047.013h0Z",
    transform: "translate(-89.606 -224.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5567",
    "data-name": "Path 5567",
    d: "M204.19,329.153a.1.1,0,0,1-.086-.053l-2.26-4.631v-.009c-.025-.066-.194-.665,1.306-1.388a11.488,11.488,0,0,0,1.038-.58c.71-.433,1.178-.721,1.615-.026.536.852,2.481,4.33,2.5,4.365a.1.1,0,0,1-.166.094c-.02-.035-1.963-3.509-2.5-4.357-.321-.51-.581-.385-1.354.087a11.858,11.858,0,0,1-1.053.589c-1.3.626-1.219,1.108-1.21,1.147l2.257,4.625a.1.1,0,0,1-.044.127.093.093,0,0,1-.042.009h0Z",
    transform: "translate(-166.168 -276.527)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5568",
    "data-name": "Path 5568",
    d: "M237.629,306.935a.1.1,0,0,1-.047-.178l7.2-4.09a.1.1,0,0,1,.094.166l-7.2,4.09a.088.088,0,0,1-.047.013h0Z",
    transform: "translate(-197.236 -259.655)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5569",
    "data-name": "Path 5569",
    d: "M254.209,291.769a.1.1,0,0,1-.043-.181l1.615-.8a.093.093,0,0,1,.126.042l.419.8a.1.1,0,1,1-.169.088l-.376-.714-1.532.754a.1.1,0,0,1-.042.01h0Z",
    transform: "translate(-211.659 -249.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M260.391,271.174a.094.094,0,0,1-.083-.048.1.1,0,0,1,.036-.13l1.788-1.008a.1.1,0,1,1,.094.166l-1.788,1.008a.1.1,0,0,1-.047.012Z",
    transform: "translate(-217.037 -231.227)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M384.984,99.38a.1.1,0,0,1-.095-.092l-.169-4.94v-.012l.806-9.061a.1.1,0,1,1,.191.017l-.806,9.056.169,4.934a.1.1,0,0,1-.092.1h0Z",
    transform: "translate(-325.279 -70.472)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5572",
    "data-name": "Path 5572",
    d: "M353.181,147.859h-.005l-2.567-.138a.1.1,0,0,1,.01-.19l2.3.124-2.6-2.323a.1.1,0,1,1,.127-.143l2.8,2.5a.1.1,0,0,1,.025.108.093.093,0,0,1-.088.059Z",
    transform: "translate(-295.323 -122.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5573",
    "data-name": "Path 5573",
    d: "M370.285,166.262h0a.1.1,0,0,1-.1-.1c0-.033.021-1.6.021-1.667a.1.1,0,0,1,.163-.066,1.3,1.3,0,0,0,.757.376c.4-.016,1.039,0,1.046,0a.1.1,0,1,1-.006.194c-.007,0-.639-.016-1.034,0a1.252,1.252,0,0,1-.739-.294c-.008.585-.018,1.437-.018,1.462a.1.1,0,0,1-.1.1h0Z",
    transform: "translate(-312.639 -139.387)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5574",
    "data-name": "Path 5574",
    d: "M385.638,109.516a.1.1,0,0,1-.079-.149,11.266,11.266,0,0,1,1.514-1.944c.1-.044.575-.4,1.074-.776a18.751,18.751,0,0,1,2.116-1.476,22.956,22.956,0,0,0,2.744-2.319s.454-.481.925-.948c.988-.982,1.087-.957,1.16-.939a23.125,23.125,0,0,1,2.228,2.3.1.1,0,0,1-.143.127c-.721-.806-1.909-2.1-2.124-2.241a16.275,16.275,0,0,0-1.911,1.83,22.3,22.3,0,0,1-2.8,2.359,18.86,18.86,0,0,0-2.077,1.453,11.7,11.7,0,0,1-1.115.8,11.777,11.777,0,0,0-1.431,1.875.1.1,0,0,1-.079.043h0Z",
    transform: "translate(-325.995 -84.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5575",
    "data-name": "Path 5575",
    d: "M467.366,99.257a.091.091,0,0,1-.068-.029.1.1,0,0,1,0-.135l1.559-1.524a.1.1,0,0,1,.134.137l-1.559,1.524a.1.1,0,0,1-.066.027Z",
    transform: "translate(-397.094 -81.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5576",
    "data-name": "Path 5576",
    d: "M494.614,24.9a.094.094,0,0,1-.075-.036c-.072-.09-1.743-2.193-2.155-2.874a23.684,23.684,0,0,1-1.172-3.125.1.1,0,1,1,.182-.057,24.159,24.159,0,0,0,1.152,3.082c.406.671,2.124,2.833,2.142,2.855a.1.1,0,0,1-.016.134.093.093,0,0,1-.06.021h0Z",
    transform: "translate(-417.917 -12.664)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5577",
    "data-name": "Path 5577",
    d: "M486.333-11.393a.1.1,0,0,1-.082-.046l-2.243-3.692a.1.1,0,0,1,.033-.131.1.1,0,0,1,.131.033l2.243,3.692a.1.1,0,0,1-.033.131.1.1,0,0,1-.049.014h0Z",
    transform: "translate(-411.642 16.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5578",
    "data-name": "Path 5578",
    d: "M454.091-2.794a.1.1,0,0,1-.079-.042l-.923-1.351a.1.1,0,0,1,.025-.133.1.1,0,0,1,.133.025l.869,1.273c1.221-.832,3.456-2.368,3.66-2.562a.1.1,0,0,1,.135,0,.1.1,0,0,1,0,.135c-.273.258-3.621,2.537-3.763,2.634a.092.092,0,0,1-.053.017h0Z",
    transform: "translate(-384.742 8.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5579",
    "data-name": "Path 5579",
    d: "M416.29,20.564a.1.1,0,0,1-.013-.19c.224-.03,5.486-.749,6.212-.812a1.375,1.375,0,0,1,1.164.384.1.1,0,0,1-.146.124,1.2,1.2,0,0,0-1-.317c-.722.062-6.148.8-6.2.812Z",
    transform: "translate(-352.66 -13.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M417.441,7.326a.1.1,0,0,1-.079-.043l-1.146-1.735a.1.1,0,0,1,.16-.1l1.146,1.735a.1.1,0,0,1-.079.148Z",
    transform: "translate(-352.665 -1.061)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M435.871,84.96a.092.092,0,0,1-.072-.033.1.1,0,0,1,.009-.135l3.629-3.172a.1.1,0,0,1,.126.144l-3.629,3.172a.1.1,0,0,1-.062.023Z",
    transform: "translate(-369.695 -67.347)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M353.153,82.739a.094.094,0,0,1-.092-.073.1.1,0,0,1,.07-.116l4.213-1.031c1.005-.838,9.064-7.542,9.55-7.718a.1.1,0,1,1,.065.179c-.346.125-5.877,4.672-9.51,7.7a.11.11,0,0,1-.039.02l-4.233,1.037h-.022Z",
    transform: "translate(-297.735 -60.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M386.822,114.538a.094.094,0,0,1-.008-.187c.012,0,1.137-.1,2.271-.261,2.1-.291,2.318-.506,2.34-.551-.026-.326-.9-1.206-1.446-1.687a.1.1,0,0,1,.126-.144c.152.133,1.483,1.315,1.511,1.823.009.174-.221.3-.8.443a16.229,16.229,0,0,1-1.626.291c-1.167.165-2.351.273-2.363.274h-.009ZM391.422,113.538Z",
    transform: "translate(-327.025 -93.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M369.28,113.007a.1.1,0,0,1-.074-.035l-4.043-4.921-3.387-3.769a.1.1,0,0,1,.143-.127l3.391,3.773,4.046,4.925a.1.1,0,0,1-.074.156h0Z",
    transform: "translate(-305.298 -86.943)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M414.826,142.365a.092.092,0,0,1-.072-.033L412.26,139.5a.1.1,0,1,1,.144-.126l2.5,2.838a.1.1,0,0,1-.072.159h0Z",
    transform: "translate(-349.216 -117.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M325.836,175.6h0l-2.324-.085a.092.092,0,0,1-.077-.043,12.469,12.469,0,0,1-.89-1.566,1.19,1.19,0,0,1-.085-.708,5.211,5.211,0,0,1-.645.234c-.131.03-.285-.085-.6-.737-.172-.359-.317-.728-.319-.732a.1.1,0,0,1,.178-.069,4.558,4.558,0,0,0,.706,1.35,8.148,8.148,0,0,0,.812-.311.1.1,0,0,1,.113.146.808.808,0,0,0,.012.756,11.9,11.9,0,0,0,.845,1.492l2.275.083a.1.1,0,0,1,0,.191h0Z",
    transform: "translate(-269.75 -145.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M290.489,201.608a.1.1,0,0,1-.048-.178c.216-.125,5.317-3.043,6.642-2.809a.1.1,0,1,1-.033.189c-1.255-.221-6.461,2.757-6.513,2.787a.092.092,0,0,1-.048.013h0Z",
    transform: "translate(-243.22 -169.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M281.569,191.4a.1.1,0,0,1-.049-.178l2.535-1.519a.1.1,0,1,1,.1.164l-2.535,1.519a.1.1,0,0,1-.049.013h0Z",
    transform: "translate(-235.461 -161.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M256.212,119.237a.1.1,0,0,1-.077-.038c-.226-.3-1.34-1.816-.986-2.272a4.521,4.521,0,0,1,1.714-.821.1.1,0,0,1,.051.185,4.231,4.231,0,0,0-1.613.753c-.194.251.46,1.345.987,2.041a.1.1,0,0,1-.075.154h0Z",
    transform: "translate(-212.5 -97.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M220.2,102.759a.1.1,0,0,1-.087-.056l-1.055-2.324a.1.1,0,0,1,.174-.078l1.055,2.324a.1.1,0,0,1-.048.126.107.107,0,0,1-.039.009h0Z",
    transform: "translate(-181.159 -83.57)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M215.147-21.65a.1.1,0,0,1-.066-.026c-.1-.1-2.554-2.427-2.8-2.731a1.9,1.9,0,0,1-.336-.657.1.1,0,0,1,.069-.116.1.1,0,0,1,.116.069h0a1.772,1.772,0,0,0,.3.585c.212.269,2.346,2.3,2.721,2.658.287-.2,1.47-1,1.769-1.291a36.505,36.505,0,0,1,3.608-1.872.1.1,0,0,1,.127.046.1.1,0,0,1-.046.127,34.727,34.727,0,0,0-3.554,1.835c-.352.343-1.8,1.315-1.86,1.356a.1.1,0,0,1-.053.016Z",
    transform: "translate(-174.977 25.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M243.462,5.536a.1.1,0,0,1-.086-.053c-.234-.475-4.062-7.119-4.1-7.187a.1.1,0,0,1,.035-.13.1.1,0,0,1,.13.035c.157.274,3.869,6.717,4.106,7.2a.1.1,0,0,1-.086.137h0Z",
    transform: "translate(-198.74 5.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5593",
    "data-name": "Path 5593",
    d: "M248.893-3.711a.094.094,0,0,1-.074-.035.1.1,0,0,1,.014-.134c1.047-.845,2.746-2.246,2.843-2.41a.1.1,0,0,1,.131-.033.1.1,0,0,1,.033.131c-.148.246-2.606,2.234-2.887,2.461a.1.1,0,0,1-.06.021h0Z",
    transform: "translate(-207.034 9.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5594",
    "data-name": "Path 5594",
    d: "M266.249-2.876a.065.065,0,0,1-.022,0A6.277,6.277,0,0,1,264.482-4a.1.1,0,0,1-.033-.072.1.1,0,0,1,.033-.072,13.315,13.315,0,0,0,1.4-1.415,9.283,9.283,0,0,1,1.823-1.4.1.1,0,0,1,.131.031.1.1,0,0,1-.031.131,9.463,9.463,0,0,0-1.766,1.342,12.156,12.156,0,0,1-1.353,1.375,5.652,5.652,0,0,0,1.579,1.008.1.1,0,0,1,.072.114.1.1,0,0,1-.092.074h0Z",
    transform: "translate(-220.651 9.697)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M258.23,7.213a.09.09,0,0,1-.059-.021,14.569,14.569,0,0,1-1.18-1.327.1.1,0,0,1,.148-.12,14.77,14.77,0,0,0,1.148,1.3.1.1,0,0,1-.06.17h0Z",
    transform: "translate(-214.145 -1.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M244.85-.142a.1.1,0,0,1-.086-.053.1.1,0,0,1,.043-.129l1.8-.9a.1.1,0,0,1,.129.043.1.1,0,0,1-.043.127l-1.8.9a.1.1,0,0,1-.043.01h0Z",
    transform: "translate(-203.517 4.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M413.017,30.151a.094.094,0,0,1-.082-.047l-.965-1.634a.1.1,0,0,1,.165-.1l.919,1.557,1.522-.776a.1.1,0,0,1,.087.17l-1.6.817a.1.1,0,0,1-.043.01Z",
    transform: "translate(-348.973 -21.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M394.431,34.146a.094.094,0,0,1-.033-.005.1.1,0,0,1-.057-.122l1.909-5.22a.1.1,0,0,1,.18.065l-1.909,5.22A.1.1,0,0,1,394.431,34.146Z",
    transform: "translate(-333.644 -21.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M350.9,46.348a.1.1,0,0,1-.091-.066l-1.347-4.133a.1.1,0,0,1,.182-.06L351,46.222a.1.1,0,0,1-.061.121.119.119,0,0,1-.03.005Z",
    transform: "translate(-294.606 -32.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5600",
    "data-name": "Path 5600",
    d: "M356.571,42.756a.1.1,0,0,1-.051-.176c.166-.1,4.072-2.548,4.838-2.57a.1.1,0,1,1,.007.191c-.593.018-3.625,1.84-4.742,2.541a.091.091,0,0,1-.051.014h0Z",
    transform: "translate(-300.709 -31.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5601",
    "data-name": "Path 5601",
    d: "M387.213,46.07a.092.092,0,0,1-.048-.013,8.387,8.387,0,0,1-1.315-2.524.1.1,0,0,1,.178-.066,7.921,7.921,0,0,0,1.232,2.426.1.1,0,0,1-.048.178Z",
    transform: "translate(-326.257 -34.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5602",
    "data-name": "Path 5602",
    d: "M313.043,84.191a.554.554,0,0,1-.169-.023.475.475,0,0,1-.319-.321.1.1,0,1,1,.181-.064.292.292,0,0,0,.193.2c.336.1.966-.3,1.181-.466a.1.1,0,1,1,.116.152,2.564,2.564,0,0,1-1.183.522Z",
    transform: "translate(-262.496 -69.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5603",
    "data-name": "Path 5603",
    d: "M312.64,97.982a.1.1,0,0,1-.034-.185l1.968-.727a.1.1,0,1,1,.066.178l-1.968.727A.1.1,0,0,1,312.64,97.982Z",
    transform: "translate(-262.49 -80.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5604",
    "data-name": "Path 5604",
    d: "M213.783-2.06a.094.094,0,0,1-.078-.042l-1.026-1.477-1.132.376a.1.1,0,0,1-.121-.061.1.1,0,0,1,.061-.121l1.2-.4a.093.093,0,0,1,.108.036l1.066,1.536a.1.1,0,0,1-.023.133.093.093,0,0,1-.055.017h0Z",
    transform: "translate(-174.519 6.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5605",
    "data-name": "Path 5605",
    d: "M481.161,267.64a.095.095,0,0,1-.066-.162c1.145-1.185,6.915-4.452,7.161-4.59a.1.1,0,0,1,.094.166c-.06.034-5.992,3.392-7.117,4.556a.094.094,0,0,1-.069.029h0Z",
    transform: "translate(-409.095 -225.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5606",
    "data-name": "Path 5606",
    d: "M489.983,261.62a.094.094,0,0,1-.078-.042l-2.059-2.96a.1.1,0,0,1,.156-.109l2.059,2.96a.1.1,0,0,1-.023.133.094.094,0,0,1-.055.017h0Z",
    transform: "translate(-414.978 -221.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5607",
    "data-name": "Path 5607",
    d: "M470.8,260.362a.1.1,0,0,1-.073-.034l-1.552-1.857a.1.1,0,1,1,.146-.122l1.49,1.786a10.324,10.324,0,0,0,1.809-1.675,30.666,30.666,0,0,0-2.5-3.245.1.1,0,1,1,.146-.122,26.4,26.4,0,0,1,2.548,3.366c0,.293-1.367,1.416-1.955,1.883a.1.1,0,0,1-.06.021ZM472.623,258.462Z",
    transform: "translate(-398.727 -218.25)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5608",
    "data-name": "Path 5608",
    d: "M441.582,272.28a.092.092,0,0,1-.048-.013.094.094,0,0,1-.034-.13c.555-.951,5.533-4.666,5.745-4.824a.1.1,0,1,1,.114.154c-.052.039-5.158,3.851-5.694,4.768a.1.1,0,0,1-.082.047h0Z",
    transform: "translate(-374.663 -228.894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5609",
    "data-name": "Path 5609",
    d: "M451.5,298.009a.1.1,0,0,1-.065-.025l-1.444-1.327a.1.1,0,0,1,.13-.14l1.444,1.327a.1.1,0,0,1,.005.135.093.093,0,0,1-.07.031h0Z",
    transform: "translate(-382.036 -254.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5610",
    "data-name": "Path 5610",
    d: "M395.945,340.409a.115.115,0,0,1-.029,0l-12.541-3.841a.1.1,0,0,1,.056-.183l12.541,3.841a.1.1,0,0,1-.027.187Z",
    transform: "translate(-324.05 -288.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5611",
    "data-name": "Path 5611",
    d: "M406.213,327.7h0a.1.1,0,0,1-.094-.1c.03-1.3-2.176-2.847-2.2-2.863a.1.1,0,0,1,.109-.156c.095.066,2.312,1.626,2.28,3.024a.1.1,0,0,1-.1.094h0Z",
    transform: "translate(-341.946 -278.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5612",
    "data-name": "Path 5612",
    d: "M417.117,327.954a.094.094,0,0,1-.064-.025l-5.157-4.622-.753.734a.1.1,0,0,1-.134-.137l.817-.8a.1.1,0,0,1,.13,0l5.224,4.681a.1.1,0,0,1-.064.166h0Z",
    transform: "translate(-348.125 -277.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5613",
    "data-name": "Path 5613",
    d: "M420.028,322.082a.09.09,0,0,1-.053-.017.1.1,0,0,1-.025-.133l.347-.506c-1.314-1.268-3.4-3.25-3.6-3.34-.1-.034-.372.265-.554.555a.1.1,0,1,1-.161-.1c.109-.174.489-.736.782-.633.251.087,3.149,2.879,3.727,3.437a.1.1,0,0,1,.013.122l-.393.574a.094.094,0,0,1-.079.042Z",
    transform: "translate(-352.461 -272.913)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5614",
    "data-name": "Path 5614",
    d: "M415.381,295.04h0a.091.091,0,0,1-.069-.034l-.551-.648a.1.1,0,1,1,.144-.125l.485.568,1.428-1.428-.385-.507a.1.1,0,1,1,.152-.116l.436.574a.1.1,0,0,1-.009.125l-1.559,1.559a.094.094,0,0,1-.068.029Z",
    transform: "translate(-351.39 -251.007)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5615",
    "data-name": "Path 5615",
    d: "M444.484,312.453a.1.1,0,0,1-.095-.1c0-.035,0-.048.181-.408.3-.615,1.213-2.487,1.03-2.816-.212-.378-3.015-3.012-4.077-4a.1.1,0,0,1,.13-.14c.157.146,3.845,3.56,4.114,4.042.2.365-.372,1.654-1.025,2.993-.077.159-.151.308-.163.343a.1.1,0,0,1-.094.077ZM444.579,312.358ZM444.579,312.358Z",
    transform: "translate(-374.668 -261.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5616",
    "data-name": "Path 5616",
    d: "M407.86,416.713a.066.066,0,0,1-.027,0c-1.433-.425-3.781-1.092-3.988-1.078-.291.021-3.907.43-3.943.434a.1.1,0,0,1-.021-.19c.15-.017,3.656-.415,3.951-.436h.01c.367,0,3.665.974,4.045,1.086a.1.1,0,0,1-.026.187h0Z",
    transform: "translate(-338.395 -357.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5617",
    "data-name": "Path 5617",
    d: "M431.632,370.059a.081.081,0,0,1-.025,0,.1.1,0,0,1-.068-.117l1.506-5.665a.094.094,0,0,1,.062-.066l3.246-1.061a.1.1,0,1,1,.06.182l-3.2,1.044-1.493,5.616a.1.1,0,0,1-.092.072h0Z",
    transform: "translate(-366.007 -312.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5618",
    "data-name": "Path 5618",
    d: "M391.817,374.254a.1.1,0,0,1-.038-.183l6.712-2.831a.1.1,0,0,1,.074.176l-6.712,2.831A.093.093,0,0,1,391.817,374.254Z",
    transform: "translate(-331.37 -319.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5619",
    "data-name": "Path 5619",
    d: "M387.663,354.591a.094.094,0,0,1-.087-.057.1.1,0,0,1,.049-.126c1.734-.757,4.379-1.942,4.557-2.1a6.861,6.861,0,0,0,.6-1.808.1.1,0,1,1,.186.043,7.075,7.075,0,0,1-.654,1.905c-.259.237-4.166,1.946-4.611,2.139a.1.1,0,0,1-.038.008Z",
    transform: "translate(-327.757 -301.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5620",
    "data-name": "Path 5620",
    d: "M413.133,372.17a.1.1,0,0,1-.09-.064l-.548-1.569a.1.1,0,1,1,.18-.063l.548,1.569a.1.1,0,0,1-.059.122.089.089,0,0,1-.031,0Z",
    transform: "translate(-349.438 -318.599)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5621",
    "data-name": "Path 5621",
    d: "M384.271,358.865a.1.1,0,0,1-.094-.078.271.271,0,0,0-.138-.2c-.342-.2-1.189.035-1.487.142a.1.1,0,0,1-.065-.179c.047-.017,1.158-.411,1.647-.127a.457.457,0,0,1,.23.328.1.1,0,0,1-.077.111Z",
    transform: "translate(-323.283 -308.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5622",
    "data-name": "Path 5622",
    d: "M-16.758,86.371a.1.1,0,0,1-.081-.044c-.039-.062-3.96-6.24-4.4-6.965a18.769,18.769,0,0,1-1.083-2.6.1.1,0,0,1,.06-.121.1.1,0,0,1,.121.06,19.178,19.178,0,0,0,1.065,2.567c.44.723,4.36,6.9,4.4,6.962a.094.094,0,0,1,.013.072.094.094,0,0,1-.043.059.091.091,0,0,1-.051.014h0Z",
    transform: "translate(28.83 -63.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5623",
    "data-name": "Path 5623",
    d: "M-32.328,172.65a.1.1,0,0,1-.091-.068.1.1,0,0,1,.062-.12l5.682-1.771a.1.1,0,0,1,.12.062.1.1,0,0,1-.062.12l-5.682,1.771a.108.108,0,0,1-.029,0h0Z",
    transform: "translate(37.611 -144.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5624",
    "data-name": "Path 5624",
    d: "M-6.126,142.416a.1.1,0,0,1-.094-.077,2.4,2.4,0,0,0-.274-.708.569.569,0,0,0-.557-.3l-.078-.008a1,1,0,0,1-.614-.464.1.1,0,0,1,.033-.131.1.1,0,0,1,.131.033h0s.213.347.47.373l.077.008a.753.753,0,0,1,.7.389,2.624,2.624,0,0,1,.3.773.1.1,0,0,1-.075.112h-.018Z",
    transform: "translate(16.153 -118.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5625",
    "data-name": "Path 5625",
    d: "M41.217,232.1a.1.1,0,0,1-.031-.186c.008,0,.721-.251.623-.566a5.083,5.083,0,0,1,.369-2.134,36.014,36.014,0,0,0,.183-4.419.1.1,0,0,1,.1-.095h0a.1.1,0,0,1,.095.1,38.647,38.647,0,0,1-.2,4.491,4.965,4.965,0,0,0-.363,2c.153.5-.709.791-.745.8a.086.086,0,0,1-.03.005h0Z",
    transform: "translate(-26.368 -191.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5626",
    "data-name": "Path 5626",
    d: "M63.411,258.547a.1.1,0,0,1-.081-.044l-6.292-9.719-1.485,1.066,1.695,2.717a.1.1,0,1,1-.161.1l-1.741-2.794a.1.1,0,0,1,.025-.127l1.639-1.178a.094.094,0,0,1,.135.025l6.347,9.8a.1.1,0,0,1-.029.133.094.094,0,0,1-.052.016h0Z",
    transform: "translate(-38.729 -212.588)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5627",
    "data-name": "Path 5627",
    d: "M76.444,252.763a.1.1,0,0,1-.088-.059l-.221-.533c-.228-.369-4.33-7.022-4.5-7.352a21.819,21.819,0,0,0-1.762-1.916l-1.194.65a.1.1,0,1,1-.092-.168l1.258-.684a.1.1,0,0,1,.113.017,23.81,23.81,0,0,1,1.847,2.013c.172.328,4.457,7.277,4.5,7.347a.061.061,0,0,1,.007.013l.224.54a.1.1,0,0,1-.052.125.092.092,0,0,1-.036.008h0Z",
    transform: "translate(-50.214 -207.49)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5628",
    "data-name": "Path 5628",
    d: "M85.4,297.78a.1.1,0,0,1-.051-.177l1.727-1.056a.1.1,0,0,1,.1.163l-1.727,1.056a.1.1,0,0,1-.049.014Z",
    transform: "translate(-64.804 -254.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5629",
    "data-name": "Path 5629",
    d: "M47.381,316.682a.1.1,0,0,1-.074-.035l-3.593-4.366a.1.1,0,0,1,.012-.134l2.247-1.9a.1.1,0,0,1,.122.146l-2.175,1.835,3.534,4.293a.1.1,0,0,1-.074.156h0Z",
    transform: "translate(-28.604 -266.245)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5630",
    "data-name": "Path 5630",
    d: "M158.724,314.353a.1.1,0,0,1-.083-.048l-4.185-7.279a.1.1,0,1,1,.165-.095l4.185,7.279a.1.1,0,0,1-.035.13.092.092,0,0,1-.048.013h0Z",
    transform: "translate(-124.952 -263.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M115.74,381.82a.061.061,0,0,1-.021,0,.1.1,0,0,1-.061-.043l-.987-1.575a.1.1,0,0,1,.161-.1l.935,1.493,3.69-2.445a.1.1,0,0,1,.105.16l-3.772,2.5a.1.1,0,0,1-.053.016h0Z",
    transform: "translate(-90.339 -326.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5632",
    "data-name": "Path 5632",
    d: "M119.545,363.283a.1.1,0,0,1-.052-.176l2.735-1.812a.1.1,0,0,1,.105.16l-2.735,1.812a.1.1,0,0,1-.052.016Z",
    transform: "translate(-94.51 -310.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5633",
    "data-name": "Path 5633",
    d: "M146.711,336.367a.1.1,0,0,1-.083-.048l-1.242-2.159-1.951,1.03a.1.1,0,0,1-.088-.169l1.946-1.027-1.851-3.218a.1.1,0,1,1,.165-.095h0l1.907,3.3a.092.092,0,0,1,.012.036l1.269,2.207a.1.1,0,0,1-.035.13.092.092,0,0,1-.048.013Z",
    transform: "translate(-115.253 -283.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5634",
    "data-name": "Path 5634",
    d: "M154.539,355.331a.1.1,0,0,1-.048-.178l7.019-4.027a.1.1,0,0,1,.1.165l-7.019,4.027A.091.091,0,0,1,154.539,355.331Z",
    transform: "translate(-124.952 -301.812)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5635",
    "data-name": "Path 5635",
    d: "M127.491,393.838a.1.1,0,0,1-.051-.176l4.218-2.641a.1.1,0,0,1,.1.161l-4.218,2.641a.091.091,0,0,1-.051.014Z",
    transform: "translate(-101.422 -336.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5636",
    "data-name": "Path 5636",
    d: "M181.149,410.04a.1.1,0,0,1-.082-.047l-3.969-6.615a.1.1,0,1,1,.164-.1l3.969,6.615a.095.095,0,0,1-.082.144h0Z",
    transform: "translate(-144.647 -347.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5637",
    "data-name": "Path 5637",
    d: "M182.86,396.932a.545.545,0,0,1-.081,0c-.467-.066-1.251-.949-1.34-1.051a.1.1,0,0,1,.144-.126c.226.259.886.939,1.223.987a2.072,2.072,0,0,0,.933-.329,3.035,3.035,0,0,1,.74-.308,1.937,1.937,0,0,0,.666-.367,1.613,1.613,0,0,1,.762-.382,2.181,2.181,0,0,0,.916-.425.1.1,0,0,1,.117.151,2.327,2.327,0,0,1-1.025.466,1.555,1.555,0,0,0-.659.347,2.034,2.034,0,0,1-.745.4,2.853,2.853,0,0,0-.685.29,2.494,2.494,0,0,1-.966.352h0Z",
    transform: "translate(-148.416 -339.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5638",
    "data-name": "Path 5638",
    d: "M250.872,365.113a.1.1,0,0,1-.085-.051l-1.623-3.039a.1.1,0,1,1,.168-.09l1.623,3.039a.1.1,0,0,1-.085.14h0Z",
    transform: "translate(-207.344 -311.181)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5639",
    "data-name": "Path 5639",
    d: "M238.611,355.315a.1.1,0,0,1-.047-.179l11.606-6.5a.1.1,0,0,1,.094.166l-11.606,6.5a.1.1,0,0,1-.047.012h0Z",
    transform: "translate(-198.09 -299.648)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5640",
    "data-name": "Path 5640",
    d: "M283.048,346.045a.1.1,0,0,1-.087-.055l-1.49-3.182a.1.1,0,1,1,.173-.082l1.49,3.182a.1.1,0,0,1-.046.127A.091.091,0,0,1,283.048,346.045Z",
    transform: "translate(-235.451 -294.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5641",
    "data-name": "Path 5641",
    d: "M276.887,350.386a.1.1,0,0,1-.082-.047l-1.8-3.02a.1.1,0,0,1,.164-.1l1.8,3.02a.1.1,0,0,1-.082.144h0Z",
    transform: "translate(-229.817 -298.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5642",
    "data-name": "Path 5642",
    d: "M367.378,354.067a.1.1,0,0,1-.094-.074l-.78-3.465a.1.1,0,1,1,.186-.042l.78,3.465a.1.1,0,0,1-.072.114h-.021Z",
    transform: "translate(-309.43 -301.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5643",
    "data-name": "Path 5643",
    d: "M339.185,368.6a.1.1,0,0,1-.075-.036l-.477-.6a.1.1,0,0,1,.15-.118l.441.555,3.483-.765a.1.1,0,1,1,.04.186l-3.541.778h-.021Z",
    transform: "translate(-285.167 -316.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5644",
    "data-name": "Path 5644",
    d: "M411.238,421.17h-.013a.1.1,0,0,1-.082-.108l.068-.5a.873.873,0,0,1-.333-.594,14.06,14.06,0,0,0-.378-1.712.1.1,0,0,1,.185-.049,14.081,14.081,0,0,1,.385,1.769c-.007.186.216.4.3.473a.1.1,0,0,1,.035.087l-.074.551a.1.1,0,0,1-.1.083h0Z",
    transform: "translate(-347.703 -360.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5645",
    "data-name": "Path 5645",
    d: "M417.619,419.777a.1.1,0,0,1-.1-.091l-.1-2.2a.1.1,0,1,1,.191-.009l.095,2.2a.1.1,0,0,1-.091.1Z",
    transform: "translate(-353.734 -359.468)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5646",
    "data-name": "Path 5646",
    d: "M127.906,418.995a.094.094,0,0,1-.055-.017.1.1,0,0,1-.023-.133,4.882,4.882,0,0,1,.926-1.038c.225-.113.913-.588,1.125-.735l-.371-.909-1.626.744a.1.1,0,0,1-.121-.036l-.35-.562a.094.094,0,0,1-.012-.074.1.1,0,0,1,.046-.06l1.7-.944a.1.1,0,0,1,.064-.01l.731.133,3.03-1.6a.1.1,0,0,1,.088.169L130,415.538a.091.091,0,0,1-.061.009l-.731-.131-1.58.879.252.406,1.64-.75a.1.1,0,0,1,.075,0,.094.094,0,0,1,.053.053l.437,1.072a.1.1,0,0,1-.034.114c-.038.026-.933.653-1.211.792a4.756,4.756,0,0,0-.856.978.1.1,0,0,1-.078.04h0Z",
    transform: "translate(-101.423 -356.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5647",
    "data-name": "Path 5647",
    d: "M137.316,409.084a.1.1,0,0,1-.085-.051l-1.337-2.491a.1.1,0,0,1,.168-.09l1.337,2.491a.1.1,0,0,1-.085.14h0Z",
    transform: "translate(-108.805 -349.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5648",
    "data-name": "Path 5648",
    d: "M194.8,413.239a.1.1,0,0,1-.048-.178l4.519-2.6a.1.1,0,0,1,.1.165l-4.519,2.6a.091.091,0,0,1-.047.013Z",
    transform: "translate(-159.976 -353.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5649",
    "data-name": "Path 5649",
    d: "M218.053,419.534a.1.1,0,0,1-.085-.051l-.493-.929a.1.1,0,0,1,.168-.09l.493.929a.1.1,0,0,1-.039.129.1.1,0,0,1-.044.012Z",
    transform: "translate(-179.777 -360.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M205.87,426.808a.1.1,0,0,1-.081-.044l-.668-1.061a.1.1,0,1,1,.161-.1l.669,1.061a.1.1,0,0,1-.03.131.091.091,0,0,1-.051.013Z",
    transform: "translate(-169.025 -366.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M200.875,305.828a.094.094,0,0,1-.082-.047l-2-3.427a.1.1,0,1,1,.164-.1l2,3.427a.1.1,0,0,1-.034.13.093.093,0,0,1-.048.013Z",
    transform: "translate(-163.523 -259.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5652",
    "data-name": "Path 5652",
    d: "M189.169,303.648a.1.1,0,0,1-.048-.178l3.725-2.154a.1.1,0,0,1,.1.165l-3.725,2.154a.092.092,0,0,1-.048.013h0Z",
    transform: "translate(-155.078 -258.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5653",
    "data-name": "Path 5653",
    d: "M174.562,328.311a.1.1,0,0,1-.046-.179l.33-.183a1.145,1.145,0,0,1-.135-.639.092.092,0,0,1,.055-.082l.965-.457a.1.1,0,0,1,.082,0l.329.159a.1.1,0,0,1,.053.086v.345a.093.093,0,0,1-.049.083l-1.539.854a.1.1,0,0,1-.047.012h0Zm.338-.935a.783.783,0,0,0,.108.467l.01.01.987-.548v-.229l-.234-.113-.871.411h0Z",
    transform: "translate(-142.37 -280.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5654",
    "data-name": "Path 5654",
    d: "M152.746,252.228a.1.1,0,0,1-.083-.048l-3.387-5.963a.1.1,0,1,1,.166-.094l3.387,5.963a.1.1,0,0,1-.036.13.088.088,0,0,1-.047.013h0Z",
    transform: "translate(-120.446 -210.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5655",
    "data-name": "Path 5655",
    d: "M156.462,200.284a.1.1,0,0,1-.081-.044l-3.45-5.508a.1.1,0,1,1,.161-.1l3.45,5.508a.1.1,0,0,1-.03.131.091.091,0,0,1-.05.013Z",
    transform: "translate(-123.623 -165.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5656",
    "data-name": "Path 5656",
    d: "M171.039,199.192a7.64,7.64,0,0,1-.446-.933c-.163-.364-.49-1.1-.869-1.972-.843-1.929-1.285-3-1.317-3.175-.049-.278-2.159-3.3-3.478-5.141a.1.1,0,1,1,.155-.111c.351.49,3.437,4.807,3.51,5.219.062.35,2.4,5.664,2.567,5.98l-.082.043h0l-.042.086h0Z",
    transform: "translate(-134.058 -159.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5657",
    "data-name": "Path 5657",
    d: "M189.2,185.4a.093.093,0,0,1-.085-.052l-1.329-2.561-4.226.226a.1.1,0,0,1-.085-.042l-4.79-7.084a.1.1,0,0,1,.159-.107l4.76,7.04,4.232-.228a.1.1,0,0,1,.09.051l1.358,2.615a.1.1,0,0,1-.04.129.088.088,0,0,1-.044.01h0Z",
    transform: "translate(-146.03 -149.249)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5658",
    "data-name": "Path 5658",
    d: "M173.3,189.939a.1.1,0,0,1-.051-.176l1.745-1.1a.1.1,0,1,1,.1.161l-1.745,1.1a.091.091,0,0,1-.049.015Z",
    transform: "translate(-141.274 -160.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5659",
    "data-name": "Path 5659",
    d: "M182.973,204.408a.1.1,0,0,1-.056-.173l1.634-1.186a.1.1,0,1,1,.113.155l-1.634,1.186a.1.1,0,0,1-.056.018Z",
    transform: "translate(-149.688 -172.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5660",
    "data-name": "Path 5660",
    d: "M200.348,170.283a.1.1,0,0,1-.079-.043l-1.252-1.89-1.691-2.934a.1.1,0,0,1,.165-.1l1.687,2.929,1.249,1.885a.1.1,0,0,1-.08.149Z",
    transform: "translate(-162.246 -140.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5661",
    "data-name": "Path 5661",
    d: "M192.219,175.108a.1.1,0,0,1-.078-.04l-1.584-2.241-.007-.01-1.464-2.8a.1.1,0,1,1,.169-.088l1.462,2.795,1.58,2.236a.094.094,0,0,1-.023.133.1.1,0,0,1-.055.017h0Z",
    transform: "translate(-155.079 -144.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5662",
    "data-name": "Path 5662",
    d: "M122.554,81.5a.1.1,0,0,1-.094-.073l-.62-2.481a.1.1,0,1,1,.185-.047l.594,2.38,3.759-1.337a.1.1,0,0,1,.064.181L122.584,81.5a.09.09,0,0,1-.033,0Z",
    transform: "translate(-96.586 -64.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5663",
    "data-name": "Path 5663",
    d: "M149.408,93.606a.1.1,0,0,1-.088-.059l-1.04-2.474a.1.1,0,0,1,.176-.074l1.04,2.474a.1.1,0,0,1-.051.125.092.092,0,0,1-.036.008Z",
    transform: "translate(-119.582 -75.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5664",
    "data-name": "Path 5664",
    d: "M17.671,34.285a.031.031,0,0,1-.021-.005.048.048,0,0,1-.022-.064c.427-.88.278-1.409-.381-2.552a2,2,0,0,0-2.214-.758q-.09.014-.159.021c-.355.04-.9,1.23-1.076,1.686a.048.048,0,1,1-.09-.035c.068-.173.676-1.692,1.154-1.745l.156-.021a2.075,2.075,0,0,1,2.31.805c.679,1.176.83,1.722.384,2.641a.047.047,0,0,1-.043.027Z",
    transform: "translate(-2.519 -23.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5665",
    "data-name": "Path 5665",
    d: "M7.268,73.325a.047.047,0,0,1-.046-.035L6.13,69.348a.047.047,0,0,1,.034-.059.048.048,0,0,1,.059.034l1.092,3.942a.047.047,0,0,1-.034.059H7.268Z",
    transform: "translate(4.074 -56.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5666",
    "data-name": "Path 5666",
    d: "M5.4,115a.048.048,0,0,1-.038-.018.049.049,0,0,1,.009-.068l1.193-.923a.047.047,0,0,1,.065.007l.575.678a18.154,18.154,0,0,0,3.724-1.334.048.048,0,1,1,.065.07A18.356,18.356,0,0,1,7.2,114.778a.043.043,0,0,1-.048-.016L6.59,114.1l-1.158.895a.052.052,0,0,1-.032,0Z",
    transform: "translate(4.745 -94.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5667",
    "data-name": "Path 5667",
    d: "M6.281,105.088a.046.046,0,0,1-.035-.016,18.962,18.962,0,0,1-1.827-2.69.048.048,0,0,1,.083-.047,18.88,18.88,0,0,0,1.813,2.67.048.048,0,0,1,0,.068.045.045,0,0,1-.033.013h0Z",
    transform: "translate(5.567 -85.369)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M123.042,143.706a.048.048,0,0,1-.038-.018l-5.378-7.056a.047.047,0,0,1,.075-.057l5.378,7.056a.048.048,0,0,1-.038.076h0Z",
    transform: "translate(-92.915 -115.16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M151.368,130.855a.05.05,0,0,1-.042-.023l-1.409-2.452a.05.05,0,0,1,0-.043.046.046,0,0,1,.033-.027l1.258-.286a.048.048,0,0,1,.021.094l-1.194.272,1.354,2.357,1.089-.537a.047.047,0,0,1,.064.022.049.049,0,0,1-.022.064l-1.129.557a.041.041,0,0,1-.021.005h0Z",
    transform: "translate(-121.01 -107.736)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M142.568,137.489a.048.048,0,0,1-.04-.022l-4.239-6.681a.048.048,0,0,1,.081-.052l4.239,6.681a.048.048,0,0,1-.014.066A.047.047,0,0,1,142.568,137.489Z",
    transform: "translate(-110.892 -110.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M134.489,177.312a.048.048,0,0,1-.026-.088l1.734-1.115a.048.048,0,1,1,.052.081l-1.734,1.115A.047.047,0,0,1,134.489,177.312Z",
    transform: "translate(-107.551 -149.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5672",
    "data-name": "Path 5672",
    d: "M236.559,107a.049.049,0,0,1-.043-.026.047.047,0,0,1,.021-.064,38.44,38.44,0,0,1,3.616-1.644.048.048,0,1,1,.017.1c-.512.094-3.558,1.619-3.59,1.635a.041.041,0,0,1-.021,0h0Z",
    transform: "translate(-196.346 -87.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5673",
    "data-name": "Path 5673",
    d: "M256.3,145.872a.047.047,0,0,1-.035-.016.048.048,0,0,1,0-.068,8.154,8.154,0,0,1,3.3-1.862.048.048,0,0,1,.016.094,8.049,8.049,0,0,0-3.254,1.838.045.045,0,0,1-.033.013h0Z",
    transform: "translate(-213.519 -121.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5674",
    "data-name": "Path 5674",
    d: "M261.559,152.977a.058.058,0,0,1-.025-.007.048.048,0,0,1-.017-.065,16.3,16.3,0,0,1,2.846-2.476.048.048,0,0,1,.066.01.047.047,0,0,1-.012.066,16.664,16.664,0,0,0-2.82,2.448.047.047,0,0,1-.042.023Z",
    transform: "translate(-218.095 -127.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5675",
    "data-name": "Path 5675",
    d: "M239.055,149.311a.046.046,0,0,1-.044-.031.048.048,0,0,1,.029-.061l1.522-.558a.048.048,0,1,1,.033.09l-1.522.558-.018,0Z",
    transform: "translate(-198.518 -125.687)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5676",
    "data-name": "Path 5676",
    d: "M245.383,166.536a.047.047,0,0,1-.042-.025l-.9-1.666a.048.048,0,0,1,.085-.046l.9,1.666a.048.048,0,0,1-.02.065.049.049,0,0,1-.022.005h0Z",
    transform: "translate(-203.239 -139.708)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5677",
    "data-name": "Path 5677",
    d: "M285.619,186.623a.048.048,0,0,1-.026-.088l5.449-3.475a.048.048,0,0,1,.052.081l-5.449,3.475A.047.047,0,0,1,285.619,186.623Z",
    transform: "translate(-239.026 -155.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5678",
    "data-name": "Path 5678",
    d: "M301.3,216.458a.048.048,0,0,1-.044-.029l-.537-1.264a.047.047,0,0,1,.087-.038l.537,1.264a.047.047,0,0,1-.025.062.05.05,0,0,1-.018.005Z",
    transform: "translate(-252.195 -183.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5679",
    "data-name": "Path 5679",
    d: "M291.639,252.761a.048.048,0,0,1-.026-.088l1.454-.923a.048.048,0,1,1,.052.081l-1.454.923a.047.047,0,0,1-.026.008Z",
    transform: "translate(-244.263 -215.364)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5680",
    "data-name": "Path 5680",
    d: "M273.255,249.376a.048.048,0,0,1-.026-.087l.769-.523-.726-1.474a.048.048,0,0,1,.022-.064.049.049,0,0,1,.064.022l.744,1.51a.049.049,0,0,1-.016.061l-.8.546a.051.051,0,0,1-.027.008h0Z",
    transform: "translate(-228.271 -211.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5681",
    "data-name": "Path 5681",
    d: "M261.542,279.227a.047.047,0,0,1-.042-.025l-4.5-8.387a.048.048,0,0,1,.085-.046l4.5,8.387a.048.048,0,0,1-.02.065.043.043,0,0,1-.022.005h0Z",
    transform: "translate(-214.165 -231.895)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5682",
    "data-name": "Path 5682",
    d: "M265.64,280.885a.048.048,0,0,1-.042-.025.047.047,0,0,1,.018-.065l1.587-.9a.048.048,0,1,1,.047.083l-1.587.9A.053.053,0,0,1,265.64,280.885Z",
    transform: "translate(-221.645 -239.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5683",
    "data-name": "Path 5683",
    d: "M217.867,278.414a.048.048,0,0,1-.04-.022l-.587-.948-.843.174a.049.049,0,0,1-.052-.023l-1.816-3.3a.048.048,0,0,1,.083-.047l1.8,3.268.84-.174a.048.048,0,0,1,.051.022l.6.977a.049.049,0,0,1-.016.066.044.044,0,0,1-.025.007Z",
    transform: "translate(-177.218 -234.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5684",
    "data-name": "Path 5684",
    d: "M191.73,363.706a.048.048,0,0,1-.042-.025l-.78-1.368a.048.048,0,1,1,.083-.047l.78,1.368a.047.047,0,0,1-.018.065.053.053,0,0,1-.023.007Z",
    transform: "translate(-156.669 -311.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5685",
    "data-name": "Path 5685",
    d: "M186.641,367.547a.048.048,0,0,1-.042-.025l-.831-1.489a.048.048,0,1,1,.083-.047l.831,1.489a.047.047,0,0,1-.018.065.053.053,0,0,1-.023.007Z",
    transform: "translate(-152.197 -314.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5686",
    "data-name": "Path 5686",
    d: "M178.1,373.871a.048.048,0,0,1-.042-.025l-1.7-3.013a.048.048,0,0,1,.083-.047l1.7,3.013a.047.047,0,0,1-.018.065.053.053,0,0,1-.023.007Z",
    transform: "translate(-144.011 -318.905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5687",
    "data-name": "Path 5687",
    d: "M168.307,379.058a.047.047,0,0,1-.042-.023l-1.868-3.172a.048.048,0,1,1,.082-.048l1.868,3.172a.048.048,0,0,1-.017.065.054.054,0,0,1-.025.007Z",
    transform: "translate(-135.346 -323.281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5688",
    "data-name": "Path 5688",
    d: "M-13.994,355.813a.047.047,0,0,1-.047-.04l-.181-1.07a23.748,23.748,0,0,1-2.331.475.047.047,0,0,1-.025-.026.047.047,0,0,1,0-.036.049.049,0,0,1,.046-.029c.09-.009,1.4-.286,2.29-.477l-.243-1.458a.047.047,0,0,1,.008-.036.047.047,0,0,1,.031-.019.047.047,0,0,1,.036.008.047.047,0,0,1,.019.031l.442,2.622a.047.047,0,0,1-.008.036.047.047,0,0,1-.031.019h-.007Z",
    transform: "translate(23.83 -303.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5689",
    "data-name": "Path 5689",
    d: "M388.225,222.886a.046.046,0,0,1-.047-.043.048.048,0,0,1,.043-.052l2.9-.3a.048.048,0,1,1,.009.1l-2.9.3Z",
    transform: "translate(-328.288 -189.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5690",
    "data-name": "Path 5690",
    d: "M365.026,231.042a.048.048,0,0,1-.047-.039.419.419,0,0,0-.432-.359c-.406.031-2.97.088-3.08.09h0a.049.049,0,0,1-.048-.047.05.05,0,0,1,.047-.049c.026,0,2.671-.059,3.075-.09a.5.5,0,0,1,.523.394l2.982-.3a.047.047,0,0,1,.052.043.048.048,0,0,1-.043.052l-3.024.308Z",
    transform: "translate(-305.01 -196.925)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5691",
    "data-name": "Path 5691",
    d: "M362.859,214.818a.047.047,0,0,1-.047-.039l-.206-1.122h-1.148a.048.048,0,0,1-.048-.048.047.047,0,0,1,.048-.048h1.189a.048.048,0,0,1,.047.039l.212,1.161a.048.048,0,0,1-.039.056h-.008Z",
    transform: "translate(-305.001 -182.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5692",
    "data-name": "Path 5692",
    d: "M360.688,222.822a.049.049,0,0,1-.048-.047.048.048,0,0,1,.047-.048l3.177-.057h0a.049.049,0,0,1,.048.047.048.048,0,0,1-.047.048Z",
    transform: "translate(-304.331 -190.074)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5693",
    "data-name": "Path 5693",
    d: "M388.954,238.566a.049.049,0,0,1-.048-.047l-.126-4.85a.049.049,0,0,1,.047-.049h0a.049.049,0,0,1,.048.047l.126,4.85a.049.049,0,0,1-.047.049Z",
    transform: "translate(-328.811 -199.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5694",
    "data-name": "Path 5694",
    d: "M389.8,259.453a.046.046,0,0,1-.047-.04.048.048,0,0,1,.04-.055l3.614-.522a.048.048,0,0,1,.014.1l-3.614.522Z",
    transform: "translate(-329.66 -221.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5695",
    "data-name": "Path 5695",
    d: "M389.325,244.285a.048.048,0,0,1-.047-.043.049.049,0,0,1,.042-.053l3.253-.36a.048.048,0,0,1,.053.042.049.049,0,0,1-.042.053l-3.253.36h-.007Z",
    transform: "translate(-329.245 -208.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M454.274,225.372a.046.046,0,0,1-.04-.023l-1.761-2.889a.044.044,0,0,1-.005-.036.043.043,0,0,1,.022-.03l3.952-2.348a.048.048,0,0,1,.048.082l-3.911,2.323,1.736,2.847a.047.047,0,0,1-.016.065.044.044,0,0,1-.025.007h0Z",
    transform: "translate(-384.214 -187.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M472.235,125.249a.052.052,0,0,1-.03-.01l-1.178-.934a.048.048,0,0,1,.06-.075l1.178.934a.048.048,0,0,1-.03.086Z",
    transform: "translate(-400.345 -104.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M474.687,116.393a.052.052,0,0,1-.03-.01.048.048,0,0,1-.008-.068l2.578-3.3a.048.048,0,0,1,.075.06l-2.578,3.3a.048.048,0,0,1-.038.018h0Z",
    transform: "translate(-403.503 -94.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M487.57,131.036a.039.039,0,0,1-.023,0l-4.673-2.552a.048.048,0,0,1,.046-.085l4.673,2.552a.049.049,0,0,1,.02.065.048.048,0,0,1-.042.025Z",
    transform: "translate(-410.646 -108.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M489.19,139.67a.047.047,0,0,1-.038-.075l1.241-1.653a.047.047,0,1,1,.075.057l-1.241,1.653a.046.046,0,0,1-.038.02h0Z",
    transform: "translate(-416.121 -116.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M340.721,19.726a.049.049,0,0,1-.043-.026L339.6,17.6a.048.048,0,1,1,.085-.043l1.082,2.1a.047.047,0,0,1-.021.064.043.043,0,0,1-.022,0Z",
    transform: "translate(-286.019 -11.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5702",
    "data-name": "Path 5702",
    d: "M272.959,57.491a.048.048,0,0,1-.044-.03l-.865-2.182a.049.049,0,0,1,.027-.062.048.048,0,0,1,.062.027L273,57.426a.049.049,0,0,1-.027.062.042.042,0,0,1-.018,0h0Z",
    transform: "translate(-227.26 -44.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5703",
    "data-name": "Path 5703",
    d: "M295.889,62.453a.049.049,0,0,1-.044-.03.047.047,0,0,1,.026-.062l1.47-.611-.62-1.708a.048.048,0,0,1,.09-.033l.636,1.751a.047.047,0,0,1-.026.06l-1.513.628h-.018Z",
    transform: "translate(-247.959 -48.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5704",
    "data-name": "Path 5704",
    d: "M297.054,63.323a.046.046,0,0,1-.044-.031.047.047,0,0,1,.027-.061l.812-.311a.047.047,0,1,1,.034.088l-.812.311h-.017Z",
    transform: "translate(-248.973 -51.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5705",
    "data-name": "Path 5705",
    d: "M300.175,68.95a.046.046,0,0,1-.044-.031.048.048,0,0,1,.029-.061l.661-.247a.048.048,0,1,1,.033.09l-.661.247Z",
    transform: "translate(-251.689 -56.048)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5706",
    "data-name": "Path 5706",
    d: "M175.583,17.873a.046.046,0,0,1-.043-.029,8.993,8.993,0,0,0-1.572-2.5.048.048,0,1,1,.051-.082,8.833,8.833,0,0,1,1.61,2.543.05.05,0,0,1-.023.064.052.052,0,0,1-.02,0h0Z",
    transform: "translate(-141.917 -9.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5707",
    "data-name": "Path 5707",
    d: "M116.74-20.8a.05.05,0,0,1-.047-.036L115.77-24.4a.048.048,0,0,1,0-.037.048.048,0,0,1,.029-.022.048.048,0,0,1,.037,0,.048.048,0,0,1,.022.029l.923,3.565a.048.048,0,0,1,0,.037.048.048,0,0,1-.029.022h-.012Z",
    transform: "translate(-91.307 24.917)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5708",
    "data-name": "Path 5708",
    d: "M100.6,107.437a.045.045,0,0,1-.042-.026l-1.414-2.664-1.9,1.014a.048.048,0,0,1-.046-.085l1.942-1.038a.045.045,0,0,1,.036,0,.051.051,0,0,1,.029.023l1.436,2.705a.049.049,0,0,1-.02.065.043.043,0,0,1-.022,0h0Z",
    transform: "translate(-75.131 -87.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5709",
    "data-name": "Path 5709",
    d: "M200.877,112.9a.047.047,0,0,1-.042-.025l-.485-.888h-.321a.046.046,0,0,1-.04-.022l-.51-.806a.048.048,0,0,1,.081-.052l.5.784h.324a.047.047,0,0,1,.042.025l.477.873,1.264-.587a.05.05,0,0,1,.064.023.048.048,0,0,1-.023.064l-1.3.6h-.02Z",
    transform: "translate(-164.124 -92.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5710",
    "data-name": "Path 5710",
    d: "M146.042,137.965a.048.048,0,0,1-.04-.022.049.049,0,0,1,.016-.066l.97-.6a.048.048,0,0,1,.051.082l-.97.6a.046.046,0,0,1-.025.008h0Z",
    transform: "translate(-117.602 -115.776)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5711",
    "data-name": "Path 5711",
    d: "M149.039,142.6a.048.048,0,0,1-.026-.088l.916-.6a.048.048,0,0,1,.052.081l-.916.6a.047.047,0,0,1-.026.007Z",
    transform: "translate(-120.209 -119.81)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5712",
    "data-name": "Path 5712",
    d: "M97.849,176.151a.049.049,0,0,1-.043-.026.047.047,0,0,1,.021-.064l3.281-1.656a.048.048,0,0,1,.043.085l-3.281,1.656a.043.043,0,0,1-.022.005h0Z",
    transform: "translate(-75.676 -148.082)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5713",
    "data-name": "Path 5713",
    d: "M187.72,239.412a.046.046,0,0,1-.047-.04,1.575,1.575,0,0,0-1.182-1.282c-.394-.135-5.2-.681-5.253-.688a.048.048,0,0,1,.012-.1c.2.022,4.869.554,5.273.692a1.665,1.665,0,0,1,1.246,1.359.048.048,0,0,1-.04.055Z",
    transform: "translate(-148.225 -202.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    "data-name": "Path 5714",
    d: "M231.908,212.362a.048.048,0,0,1-.048-.048V210.6a.046.046,0,0,1,.021-.039l1.156-.779a.048.048,0,1,1,.053.079l-1.135.765v1.693a.048.048,0,0,1-.048.048h0Z",
    transform: "translate(-192.3 -178.85)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    "data-name": "Path 5715",
    d: "M224.162,203.719a.046.046,0,0,1-.036-.017.048.048,0,0,1,.007-.068l1.587-1.329a.048.048,0,1,1,.061.074l-1.587,1.329a.047.047,0,0,1-.031.012h0Z",
    transform: "translate(-185.562 -172.348)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5716",
    "data-name": "Path 5716",
    d: "M457.81,193.05a.048.048,0,0,1-.026-.088l.584-.372a.048.048,0,0,1,.052.081l-.584.372a.047.047,0,0,1-.026.007Z",
    transform: "translate(-388.821 -163.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5717",
    "data-name": "Path 5717",
    d: "M460.3,196.965a.048.048,0,0,1-.025-.088l.581-.355a.047.047,0,1,1,.049.081l-.581.355a.044.044,0,0,1-.025.007h0Z",
    transform: "translate(-390.99 -167.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5718",
    "data-name": "Path 5718",
    d: "M462.532,200.172a.048.048,0,0,1-.04-.022.049.049,0,0,1,.016-.066l.553-.342a.048.048,0,1,1,.051.082l-.553.342a.044.044,0,0,1-.025.007Z",
    transform: "translate(-392.93 -170.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5719",
    "data-name": "Path 5719",
    d: "M473.871,193.534a.046.046,0,0,1-.036-.017.049.049,0,0,1,.005-.068l2.19-1.84a.049.049,0,0,1,.035-.01.042.042,0,0,1,.033.018l1.018,1.281a.048.048,0,0,1-.075.06l-.988-1.243-2.152,1.809a.047.047,0,0,1-.031.012h0Z",
    transform: "translate(-402.794 -163.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5720",
    "data-name": "Path 5720",
    d: "M483.97,175.906h-.017a.047.047,0,0,1-.027-.061c.148-.389-.719-1.862-1.066-2.4a.048.048,0,0,1,.081-.052c.052.081,1.272,1.97,1.076,2.484a.049.049,0,0,1-.044.031h0Z",
    transform: "translate(-410.648 -147.187)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5721",
    "data-name": "Path 5721",
    d: "M481.489,181.087a.044.044,0,0,1-.039-.021.046.046,0,0,1,.012-.066l.644-.45a.048.048,0,0,1,.055.078l-.644.45a.053.053,0,0,1-.028.009Z",
    transform: "translate(-409.421 -153.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5722",
    "data-name": "Path 5722",
    d: "M485.386,185.259a.05.05,0,0,1-.047-.036.049.049,0,0,1,.03-.057c.036-.018.281-.2.5-.359a.047.047,0,0,1,.057.075,3.6,3.6,0,0,1-.527.375h-.01Z",
    transform: "translate(-412.811 -157.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5723",
    "data-name": "Path 5723",
    d: "M375.681,470.794h0l-4.345-.271a.047.047,0,0,1-.044-.051.046.046,0,0,1,.051-.044l4.345.271a.048.048,0,0,1,0,.1h0Z",
    transform: "translate(-313.594 -405.609)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5724",
    "data-name": "Path 5724",
    d: "M384.364,459.914a.05.05,0,0,1-.047-.036c-.01-.042-.258-1.039.1-1.49a.59.59,0,0,1,.5-.217.047.047,0,0,1,0,.095h0a.486.486,0,0,0-.42.181c-.328.415-.085,1.4-.082,1.407a.048.048,0,0,1-.035.059h-.012Z",
    transform: "translate(-324.848 -394.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5725",
    "data-name": "Path 5725",
    d: "M246.88,395.571h-.007l-.5-.064a.047.047,0,0,1-.042-.044l-.069-1.151a.048.048,0,0,1,.044-.051.047.047,0,0,1,.051.044l.066,1.112.434.055.263-.434-.429-.9a.048.048,0,1,1,.086-.042l.441.929a.047.047,0,0,1,0,.046l-.291.483a.049.049,0,0,1-.04.023Z",
    transform: "translate(-204.827 -339.177)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5726",
    "data-name": "Path 5726",
    d: "M214.745,351.772a.046.046,0,0,1-.044-.031.048.048,0,0,1,.029-.061,17.521,17.521,0,0,0,3.986-2.042.048.048,0,0,1,.064.072,17.625,17.625,0,0,1-4.016,2.061.038.038,0,0,1-.017,0h0Z",
    transform: "translate(-177.369 -300.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5727",
    "data-name": "Path 5727",
    d: "M133.377,372.809a.047.047,0,0,1-.025-.088l1.717-1.014a.048.048,0,0,1,.048.082L133.4,372.8a.054.054,0,0,1-.025.007Z",
    transform: "translate(-106.584 -319.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5728",
    "data-name": "Path 5728",
    d: "M134.966,391.528a.046.046,0,0,1-.038-.02l-.432-.576a.047.047,0,1,1,.075-.057l.432.576a.048.048,0,0,1-.009.066.047.047,0,0,1-.029.009h0Z",
    transform: "translate(-107.591 -336.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5729",
    "data-name": "Path 5729",
    d: "M460.242,39.716a.046.046,0,0,1-.036-.018l-1.857-2.281a.048.048,0,1,1,.074-.061l1.857,2.281a.049.049,0,0,1-.007.068.044.044,0,0,1-.03.01h0Z",
    transform: "translate(-389.323 -28.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5730",
    "data-name": "Path 5730",
    d: "M454.014,46.518a.05.05,0,0,1-.034-.014.047.047,0,0,1,0-.068l3.2-3.236-1.094-1.245-2.362,2.237-.933.912a.048.048,0,0,1-.068-.068l.934-.913,2.4-2.271a.048.048,0,0,1,.069,0l1.156,1.316a.048.048,0,0,1,0,.065L454.046,46.5a.05.05,0,0,1-.034.014h0Z",
    transform: "translate(-384.431 -32.762)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5731",
    "data-name": "Path 5731",
    d: "M486.906,44.288a.048.048,0,0,1-.026-.087l1.777-1.215a.048.048,0,0,1,.053.079l-1.777,1.215a.051.051,0,0,1-.027.008Z",
    transform: "translate(-414.134 -33.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5732",
    "data-name": "Path 5732",
    d: "M467.526-.24a.049.049,0,0,1-.043-.026c-.166-.332-1.989-2.8-2.007-2.821a.047.047,0,0,1-.009-.035.047.047,0,0,1,.019-.031.047.047,0,0,1,.035-.009.047.047,0,0,1,.031.019c.075.1,1.846,2.5,2.015,2.835a.047.047,0,0,1,0,.036.047.047,0,0,1-.024.028.041.041,0,0,1-.021.005h0Z",
    transform: "translate(-395.525 6.388)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5733",
    "data-name": "Path 5733",
    d: "M421.529,108.78a.043.043,0,0,1-.022,0c-.161-.086-1.492-1.963-1.757-2.338a.048.048,0,1,1,.078-.055c.606.858,1.61,2.243,1.723,2.309a.048.048,0,0,1-.023.09Z",
    transform: "translate(-355.745 -88.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5734",
    "data-name": "Path 5734",
    d: "M458.24,141.029a.046.046,0,0,1-.035-.016l-1.411-1.552a.048.048,0,0,1,.07-.065l1.411,1.552a.048.048,0,0,1,0,.068A.051.051,0,0,1,458.24,141.029Z",
    transform: "translate(-387.968 -117.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5735",
    "data-name": "Path 5735",
    d: "M439.745,130.091a.046.046,0,0,1-.036-.017l-.434-.509c-.269-.315-.384-.28-.484-.248a.231.231,0,0,1-.2-.007.758.758,0,0,1-.3-.407l-.026-.061a1.785,1.785,0,0,0-.693-.367.049.049,0,0,1-.03-.061.05.05,0,0,1,.061-.03c.112.038.671.239.749.419l.026.062a.67.67,0,0,0,.261.362c.04.023.07.016.127,0,.151-.047.3-.059.585.277l.434.509a.049.049,0,0,1-.005.068.047.047,0,0,1-.031.012h0Z",
    transform: "translate(-371.223 -108.049)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5736",
    "data-name": "Path 5736",
    d: "M454.794,169.7a.044.044,0,0,1-.039-.021l-1.793-2.541a.048.048,0,0,1-.008-.038.046.046,0,0,1,.022-.031l1.529-.933-1.487-2.446a.047.047,0,0,1,.016-.065.048.048,0,0,1,.065.016l1.511,2.487a.047.047,0,0,1-.016.065l-1.527.931,1.764,2.5a.047.047,0,0,1-.012.066.043.043,0,0,1-.027.009h0Z",
    transform: "translate(-384.638 -138.702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5737",
    "data-name": "Path 5737",
    d: "M455.016,268.177a.1.1,0,0,1-.069-.03l-1.783-1.857-1.038-1.038a.095.095,0,0,1,.008-.14l2.1-1.727-.238-.352a.1.1,0,1,1,.159-.107l.286.424a.1.1,0,0,1-.018.127l-2.083,1.715.965.965,1.784,1.858a.1.1,0,0,1,0,.135.093.093,0,0,1-.066.026h0Z",
    transform: "translate(-383.895 -225.056)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5738",
    "data-name": "Path 5738",
    d: "M432.756,298.6a.1.1,0,0,1-.059-.02l-1.535-1.182a.1.1,0,0,1,.117-.151l1.535,1.182a.1.1,0,0,1,.017.134.094.094,0,0,1-.075.038h0Z",
    transform: "translate(-365.649 -254.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5739",
    "data-name": "Path 5739",
    d: "M379.1,385.665a.1.1,0,0,1-.021-.189l.953-.222a.1.1,0,0,1,.043.186l-.953.222H379.1Z",
    transform: "translate(-320.304 -331.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5740",
    "data-name": "Path 5740",
    d: "M272.41,73.243l2.064-.883,1.124,2.273-2.233.767Z",
    transform: "translate(-227.576 -59.313)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5741",
    "data-name": "Path 5741",
    d: "M350.44,96.68a.265.265,0,0,1,.334-.2c.265.074.451.891.546.96s.4-.176.434-.038a3.905,3.905,0,0,0,.25.541l-.551.711-1.013-1.979h0Z",
    transform: "translate(-295.458 -80.288)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5742",
    "data-name": "Path 5742",
    d: "M15.87,34.992l.117-.648.485-.658.714-.3,1.125.042.774.7.356,1.137-.558.927-.934.4-1.187.337-.711-1.124Z",
    transform: "translate(-4.401 -25.411)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5743",
    "data-name": "Path 5743",
    d: "M339.35,399.5s.467-.133.546-.064.181-.1.207-.159.211-.021.211-.021-.073.092.022.114,1.444-.38,1.444-.38a12.874,12.874,0,0,1,2.143-.339c.107.107.814,3.679.814,3.679h.243l.147.62-.183.048.462,2.029s-1.712-.031-1.687.207-.023,1.87-.023,1.87h-1.758l.064.319h-.645s-.263.056-.334-.056-.079-.151-.008-.239-.178-.515-.189-.88-.594-3.586-.594-3.586a14.312,14.312,0,0,1-.36-1.714c.031-.191-.245-.574-.245-.574s.222-.255.09-.377a3.512,3.512,0,0,1-.365-.5Z",
    transform: "translate(-285.81 -343.152)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5744",
    "data-name": "Path 5744",
    d: "M337.983,472.8a20.633,20.633,0,0,1,.493-2.149c.151-.311.717-1.416.724-1.488s.661,0,.661,0a4.719,4.719,0,0,0,0,.581.59.59,0,0,1,0,.286c-.023.127-.072,1.051-.072,1.051l-.239.016-.04-.2s-.342-.159-.438-.008-.4-.048-.4.263a1.15,1.15,0,0,1-.064.446l-.135.056.023,1.233a.814.814,0,0,1-.518-.087h0Z",
    transform: "translate(-284.618 -404.485)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5745",
    "data-name": "Path 5745",
    d: "M449.965,364.688l-1.575,6.637,1.575.462,1.847-7.464s-.4-.483-1.416.117-.429.25-.429.25h0Z",
    transform: "translate(-380.668 -313.143)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5746",
    "data-name": "Path 5746",
    d: "M256.95,360.736l3.108-1.676.765,1.422-2.95,1.614Z",
    transform: "translate(-214.127 -308.725)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M213.644,400.55l1.475,2.419-2.462,1.559a.492.492,0,0,1-.222-.291,25.09,25.09,0,0,1-1.48-2.143,20.509,20.509,0,0,1,2.689-1.544Z",
    transform: "translate(-174.11 -344.819)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M191.28,418.681l.848-.551.127.222.308-.222.456.732-1.2.572Z",
    transform: "translate(-156.997 -360.113)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5749",
    "data-name": "Path 5749",
    d: "M197.27,422.5l.961,1.475,2.355-1.411-.892-1.4-1.1.666.458.631-.339.26-.479-.753Z",
    transform: "translate(-162.208 -362.757)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5750",
    "data-name": "Path 5750",
    d: "M134.82,451.169l2.016,3.236,1.687-1.115s-.265-.085-.265-.222-.1-.245-.031-.372-.265-.35-.308-.551a1.329,1.329,0,0,0-.451-.626c-.228-.2-.271-.191-.414-.021a1.779,1.779,0,0,1-.546.329l-.17-.043s-.064.107-.1.148a.8.8,0,0,1-.225.107l-.793-1.2-.4.329Z",
    transform: "translate(-107.881 -388.569)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5751",
    "data-name": "Path 5751",
    d: "M161.425,437.634s.074.17,0,.212-.053.127-.064.255-.276.074-.053.265a2.675,2.675,0,0,0,.477.319c.265.17.255-.053.255.3s-.265.52.053.6,4.042-2.547,4.042-2.547l-.562-1.125-.127.053-.191-.308-.434.212-.212-.212-3.182,1.973h0Z",
    transform: "translate(-130.846 -375.363)",
    fill: "#bdbdbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5752",
    "data-name": "Path 5752",
    d: "M142.84,459.47s.456-1.316.748-1.38a15.077,15.077,0,0,0,1.583-.467c.364-.148,3.484-1.167,3.908-1.444s5.687-2.207,5.687-2.207l4.542-1.868s3.1-1.252,3.374-1.74.446-1.146,1.358-1.21,1.973-.722,2.738-.339.934.107,1,1.039a6.747,6.747,0,0,1-.4,2.419c-.085.107-.447.319-.446.265s-.488.265-.338-.2a2.2,2.2,0,0,0,.148-.985c0-.5.043-1.181-.319-1.181s-2.4.148-2.738.584a4.3,4.3,0,0,1-1.125.947c-.148.061-.043-.13-.36.421s-.763.743-.8.88,0,.812.09.844.493.117.6.038.217-.525.217-.525a4.883,4.883,0,0,1,1.258-.25l1.475.016s.748-.377.817-.446a3.512,3.512,0,0,1,.822-.053,2.6,2.6,0,0,1,.09.87c-.053.36-.117.467-.191.5s-2.059,1.449-2.059,1.449l-1.141.053s-.913-.827-1.21-.791a18.455,18.455,0,0,0-1.985.865l-2.69-.186a10.383,10.383,0,0,0-2.4.2c-.393.217-2.573.78-2.886.949s-3.57,1.8-3.57,1.8l-.642.016-.164.482-1.194.817-1.883.064-.727.977s-.17.217-.62.048a1.03,1.03,0,0,1-.631-.769c.005-.122.069-.515.069-.515h0Z",
    transform: "translate(-114.796 -386.704)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5753",
    "data-name": "Path 5753",
    d: "M469.115,262.971s0-.13-.956.71c-.9.8-2.716,2.358-2.716,2.358s-.955.467-1.146,1.1a34.164,34.164,0,0,1-2.5,3.735s-1.506,2.57-1.847,3.323a40.774,40.774,0,0,0-2.25,5.745c-.148,1.118-1.358,5.724-1.358,5.724l.276.722s-.191,1.337-.424,1.485-1.4,10.441-1.4,10.441a1.455,1.455,0,0,1,.265,1.245c-.107.907-.265,2.511-.265,2.511h9.226l.668-5.555-.143-.127.191-1.559s1.178-7.815,1.432-8.627,1.225-5,2.149-6.542a32.761,32.761,0,0,1,2.054-3.575c.382-.276.271-1.422,1.385-1.771a3.292,3.292,0,0,0,1.464-.763l.016-3.342-4.116-7.238h0Z",
    transform: "translate(-386.236 -225.127)",
    fill: "#d4d4d4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(-14617 467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3705",
    "data-name": "Path 3705",
    d: "M0,15,20,5,40,15V40L20,50,0,40Z",
    transform: "translate(116 317)",
    fill: "#5758a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3706",
    "data-name": "Path 3706",
    d: "M0,14,18,5l18,9L18,23Z",
    transform: "translate(118 342)",
    fill: "#00ffec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "CTC_-_Logo_Purple_kopie",
    "data-name": "CTC - Logo Purple kopie",
    transform: "translate(-396 324.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2000",
    "data-name": "Rectangle 2000",
    width: 20,
    height: 20,
    transform: "translate(522 2.2)",
    fill: "#5758a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M1016.79,443.313a.584.584,0,0,1-.08.3c-.036.046-.071.093-.11.136a2.389,2.389,0,1,1,.02-3.087c.026.031.049.06.074.093a.581.581,0,0,1,.094.32.588.588,0,0,1-1.01.411,1.11,1.11,0,0,0-.074-.094,1.22,1.22,0,1,0-.114,1.721,1.169,1.169,0,0,0,.123-.125.716.716,0,0,0,.054-.068.588.588,0,0,1,.831-.032.57.57,0,0,1,.191.432Z",
    transform: "translate(-482.83 -430.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4778",
    "data-name": "Path 4778",
    d: "M638.43,494.491v1.348a.092.092,0,0,1-.091.093,4.893,4.893,0,0,0-4.156,2.458h0a4.9,4.9,0,0,1-8.387.08q-.06-.109-.125-.213a4.888,4.888,0,0,0-3.989-2.323h-.091a.093.093,0,0,1-.091-.093v-1.348a.093.093,0,0,1,.093-.093h.144a6.39,6.39,0,0,1,3.348,1.087,6.461,6.461,0,0,1,1.874,1.937,3.246,3.246,0,0,0,.2.34,3.367,3.367,0,0,0,5.636-.036c.055-.086.108-.176.156-.269h0a6.455,6.455,0,0,1,1.893-1.97,6.389,6.389,0,0,1,3.492-1.091.09.09,0,0,1,.1.09Z",
    transform: "translate(-97.964 -484.602)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapCityIcon);
export default __webpack_public_path__ + "static/media/mapCityIcon.e04c0b1f37c7e2c0807a285a70a48cd5.svg";
export { ForwardRef as ReactComponent };